$(document).ready(function() {
    if ($('#app-post-table').length) {

        var progress_loader_steps = 0;
        var progress_loader_curr_step = 0;
        var update_progress_loader = function (message, steps) {
            var container = $('#progressloader');

            progress_loader_curr_step++;
            width = (progress_loader_curr_step / progress_loader_steps) * 100;
            container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
            if (steps === true) {
                message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
            }
            container.find('span').html(message + '...');
            if (progress_loader_steps <= progress_loader_curr_step)
                close_progress_loader();
        };

        var init_progress_loader = function (steps, message) {
            progress_loader_steps = steps;
            progress_loader_curr_step = 0;

            update_progress_loader(message);

            $('#progressloader').show();
        };

        var close_progress_loader = function () {
            progress_loader_steps = 0;
            progress_loader_curr_step = 0;
            $('#progressloader').hide();
        };

        var data_table_order = [0, "desc"];
        var app_post_table = $('#app-post-table').DataTable({
            order: data_table_order,
            columns: [
                {data: 'id'},//0
                {data: 'name'},//1
                {data: 'advertiser_name'},//2
                {data: 'campaign_name'},//3
                {data: 'market_name'},//4
                {data: 'type'},//5
                //  {data: 'vendor_name'},//6
                {data: 'created_at'},//6
                {data: 'id'}//7
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "visible": false,
                },
                {
                    "targets": 5,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (cellData == 'dma')
                            $(td).html('Television');
                        else
                            $(td).html('Radio');
                    }
                },
                {
                    "targets": 6,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        $(td).html(date.format('MM/DD/YYYY'));
                    }
                },
                {
                    "targets": 7,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<div class="btn-group">\n' +
                            '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                            '                <i class="fa fa-ellipsis-v"></i>\n' +
                            '                <span class="sr-only">Toggle Dropdown</span>\n' +
                            '            </button>\n' +
                            '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                            '                <li class="ms-hover">' + '<a onclick="init_progress_loader(2, \'This query might take a few seconds. Please wait ...\')" href="/post/report/view/' +
                            cellData +
                            '" >' + '<i class="fa fa-eye"></i> View' + '</a>' + '</li>\n' +
                            '                <li class="ms-hover">' + '<a class="edit-report" href="/post/edit/configuration/' + cellData + ' " >' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                            '                <li role="separator" class="divider ms-hover"></li>\n' +
                            '                <li class="ms-hover"><a href="javascript:void(0)" class="delete-report" data-row="' + row + '" data-id="' + cellData + '" ><i class="fa fa-trash-o"></i> Delete</a></li>\n'
                        '            </ul>\n' +
                        '        </div>';



                        // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                        //     '<a onclick="init_progress_loader(2, \'This query might take a few seconds. Please wait ...\')" href="/post/report/view/' +
                        //     cellData +
                        //     '" role="button" class="btn btn-info btn-sm">' +
                        //     '<i class="fa fa-eye"></i> View' +
                        //     '</a>' +
                        //     '<a href="/post/edit/configuration/' + cellData + ' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                        //     '<i class="fa fa-pencil"></i> Edit' +
                        //     '</a>' +
                        //     '</div>' +
                        //     '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-row="' + row + '" data-id="' + cellData + '" role="button">' +
                        //     '<i class="fa fa-trash-o"></i> Delete' +
                        //     '</a></div>';
                        $(td).html(html);
                    }
                }
            ]
        });
        $('#app-post-table').on('length.dt', function (e, settings, len) {
            user_entries = len;
        });
        $('#app-post-table').on('order.dt', function (e, settings, len) {
            data_table_order = [len[0].col, "" + len[0].dir + ""];
        });
        $.ajax({
            type: 'GET',
            url: '/post/list',
            dataType: 'json',
            encode: true,
            success: function (response) {
                app_post_table.clear();
                app_post_table.rows.add(response);
                app_post_table.draw();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
            }
        });
        $('#app-post-table').on('click', '.delete-report', function () {
            $.ajax({
                type: 'GET',
                url: '/post/report/delete/' + $(this).attr('data-id'),
                dataType: 'json',
                encode: true,
                success: function (response) {
                    global_notification('success', 'Report deleted...');
                    app_post_table.row($(this).attr('data-row')).remove().draw();
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        });
    }
    var  overal_global_var = [];
    $('#report_details_p').on('click', function () {
        if (!$(this).hasClass('expanded')) {
            $('#main_grid_div').css('height', '35vh');
            $('.media-totals-wrapper').css('height', '30vh').show();
            $(this).addClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        } else {
            $('#main_grid_div').css('height', '70vh');
            $('.media-totals-wrapper').css('height', '0').hide();
            $(this).removeClass('expanded');
            $(this).find('i').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        }
    });

    if ($('.report-content-complety').length) {

        function fill_report_details(top_line, station_totals) {
            var rating_total = 0;
            var rating_diff_total = 0;
            var last_rating = -1;
            var tables_to_export_excel = '';
            var htmlx = '';
            var htmlx = '<table  style=";width: 100%;border-top: 1px solid black; border-left: 1px solid black;border-right: 1px solid black;background-color: #373737; ' +
                ' height: 20px;\n' +
                '                        margin-left: 0%;\n' +
                '                        background-color: #373737 !important;\n' +
                '                        color: whitesmoke !important;\n' +
                '                        border-bottom: none !important;\n' +
                '                        font-weight: 600 !important;\n' +
                '                        font-size: 11px;\n' +
                '                        line-height: 20px;\n' +
                '                        text-transform: uppercase;\n' +
                '                        text-align: center;\n' +
                '                        cursor: pointer;">' +
                '<tr><td style="color: white">Campaign: ' + campaign.name + '</td>' +
                '<td style="color: white">Advertiser: ' + campaign.advertiser_name + '</td>' +
                '<td style="color: white"> </td></tr>' +
                '</table>';
            $('.report-content-header').html('');
            $('.report-content-header').html(htmlx);
            var html = '';

            var colspan = 0;
            var colspan_1 = 0;
            if (metrics.indexOf('grp') !== -1) {
                colspan += 2;
                colspan_1 += 1;
            }
            if (metrics.indexOf('impressions') !== -1) {
                colspan += 2;
                colspan_1 += 1;
            }
            var  network_column_colspan = (imp_type === 'Thousands') ? 3 : 2;
            var pading = '150px !important';
            pading = colspan === 4 ? '300px !important' : pading;

            html += '<table style="font-size: 12px; color: black;width: 100%; border-top: 1px solid black;  border-bottom: 1px solid black;  border-right: 1px solid black;">' +
                '<tr style="white-space: nowrap; background-color: #8E2215">' +
                '<th colspan="2" style="color: white; "></th>' +
                '<th colspan="'+ network_column_colspan +'" style="color: white"></th>' +
                '<th colspan="4" style="color: white"></th>' +//rate, SL, ISCI, Week
                '<th colspan="' + colspan + '" style="border-right: 1px solid black; border-left: 1px solid black; color: white; padding-right: '+ pading +' "><b>' + main_demo + '  ('+ report_type +')</b></th>' +//old data,
                '<th colspan="' + colspan + '" style="border-right: 1px solid black; color: white;  padding-right: '+ pading +'"><b>' + main_demo + ' (Delivered)</b></th>' +//new data,
                '<th colspan="' + colspan_1 + '" style="border-right: 1px solid black; color: white;  padding-right: 150px !important"><b>' + main_demo + ' Percent Delivered</b></th>' ;

            var sec_de_colspan = 0;
            for (var ind in secondary_demos) {
                var text = secondary_demos[ind][0].demo_source !== 'comscore' ? secondary_demos[ind][0].demo_type.toUpperCase() + '-' + secondary_demos[ind][0].demo_name : secondary_demos[ind][0].demo_name;
                html += '<th colspan="' + colspan + '" style="border-right: 1px solid black; border-left: 1px solid black; color: white; padding-right: ' + pading + '"><b> ' + text + '  (' + report_type + ')</b></th>' +//old data,
                    '<th colspan="' + colspan + '" style="border-right: 1px solid black; color: white; padding-right: ' + pading + '"><b>' + text + '  (Delivered)</b></th>' +//new data,
                    '<th colspan="' + colspan_1 + '" style="border-right: 1px solid black; color: white;  padding-right: 150px !important"><b> ' + text + ' Percent Delivered</b></th>';

                sec_de_colspan++;
            }
            html +=  '</tr>' +
                '<tr style="background-color: rgba(142, 34, 21, 0.3) !important; border-bottom: 1px solid black">' +
                '<th></th><th style="padding-left:0%; color: black; padding-right: 300px"><b>Time</b></th>' +
                '<th></th>' ;
            if(network_column_colspan === 3)
                html += '<th style=" color: black; padding-right: 150px"><b>Network</b></th>';

            html += '<th style="color: black; padding-right: 150px"><b>Program</b></th>' +
                '<th style="color:black; padding-right: 100px"><b>Rate</b></th><th style="color:black;  padding-right: 100px"><b>SL</b></th>' +
                '<th style="color:black;  padding-right: 100px"><b>ISCI</b></th><th style="border-right: 1px solid black; color:black;  padding-right: 100px"><b>Week</b></th>';

            var border = '';
            //Main demo
            if (metrics.indexOf('impressions') === -1)
                border = 'border-right: 1px solid black;';
            if (metrics.indexOf('grp') !== -1)
                html += '<th style="color:black"><b>GRP</b></th><th style="' + border + ' color:black"><b>CPP</b></th>';
            if (metrics.indexOf('impressions') !== -1)
                html += '<th style="color:black"><b>' + imp_type + '</b></th><th style="border-right: 1px solid black; color:black"><b>CPM</b></th>';
            if (metrics.indexOf('grp') !== -1)
                html += '<th style="color:black"><b>GRP</b></th><th style="' + border + ' color:black"><b>CPP</b></th>';
            if (metrics.indexOf('impressions') !== -1)
                html += '<th style="color:black"><b>' + imp_type + '</b></th><th style="border-right: 1px solid black; color:black"><b>CPM</b></th>';
            var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';

            if (metrics.indexOf('grp') !== -1)
                html += '<th style="' + border + ' color:black; '+ b_lef_imp +'"><b>GRP %</b></th>';
            var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-right: 1px solid black' : '';
            if (metrics.indexOf('impressions') !== -1)
                html += '<th style="' + border + ' color:black; '+ b_lef_imp +'"><b>'+imp_type + ' %</b></th>';

            //Sec Demos
            for (var ind in secondary_demos) {
                var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-left: 1px solid black' : '';
                if (metrics.indexOf('grp') !== -1)
                    html += '<th style="color:black;  border-left: '+ b_lef_imp +'"><b>GRP</b></th><th style="' + border + ' color:black;"><b>CPP</b></th>';
                var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-left: 1px solid black' : '';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th style="color:black; border-left: '+ b_lef_imp +'"><b>' + imp_type + '</b></th><th style="border-right: 1px solid black; color:black"><b>CPM</b></th>';
                if (metrics.indexOf('grp') !== -1)
                    html += '<th style="color:black"><b>GRP</b></th><th style="' + border + ' color:black"><b>CPP</b></th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th style="color:black"><b>' + imp_type + '</b></th><th style="border-right: 1px solid black; color:black"><b>CPM</b></th>';

                var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                var ss = border !== '' ? border +';' : '';
                if (metrics.indexOf('grp') !== -1)
                    html += '<th style="' + ss + ' color:black; '+ b_lef_imp +'"><b>GRP %</b></th>';

                var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-right: 1px solid black' : '';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th style="' + ss + ' color:black; '+ b_lef_imp +'"><b>'+imp_type + ' %</b></th>';
            }


            html += '</tr>';


            // html += '<tr style="background-color:#eaeaea"></tr>';
            var spots = 0;
            var total_gross = 0;
            var cont_index = 0;
            for (var vnd_id in result) {
                var data = result[vnd_id];
                var v_name = '';
                var station = [];
                var vnd_id_trade = vnd_id.split('_')[0];
                if (typeof vendor[vnd_id_trade] !== 'undefined') {
                    v_name = vendor[vnd_id_trade][0].name;
                    v_name = vnd_id.indexOf('_1') !== -1 ? v_name + ' - Trade' : v_name;
                    station = vendor[vnd_id_trade][0];
                }


                if(cont_index == 0) {
                    //TOP LINE DETAILS
                    var ord_gross = 0;
                    var ord_ads = 0;
                    var ord_gri = 0;
                    var ord_grp = 0;
                    var sec_demos_array = [];
                    for (var i in stations_values) {
                        ord_gross += parseFloat(stations_values[i]['total'][1]);
                        ord_ads += parseInt(stations_values[i]['total'][0]);
                        ord_gri += parseFloat(stations_values[i]['total'][3]);
                        ord_grp += parseFloat(stations_values[i]['total'][2]);

                        for(var ind in secondary_demos) {
                            if(typeof sec_demos_array['imp_goal_' + ind] === 'undefined'){
                                sec_demos_array['imp_goal_' + ind] = 0;
                                sec_demos_array['grp_goal_' + ind] = 0 ;
                            }
                            sec_demos_array['imp_goal_' + ind] += stations_values[i]['total']['sec_demos'][ind]['imp'];
                            sec_demos_array['grp_goal_' + ind] += stations_values[i]['total']['sec_demos'][ind]['rat'];
                        }
                    }
                    top_line.grp_goal = ord_grp;
                    top_line.imp_goal = ord_gri;
                    top_line.total_goal = ord_gross;

                    var cpp = ((Math.round(top_line.grp * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / (Math.round(top_line.grp * 10) / 10) : 0;
                    var cpp_goal = ((Math.round(top_line.grp_goal * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / (Math.round(top_line.grp_goal * 10) / 10) : 0;

                    var div = (report.type === 'msa') ? 10 : 1;
                    var cpm = ((Math.round(top_line.impressions * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / ((Math.round(top_line.impressions * 10) / 10) / div) : 0;
                    var cpm_goal = ((Math.round(top_line.imp_goal * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / ((Math.round(top_line.imp_goal * 10) / 10) / div) : 0;

                    var cpp = ((Math.round(top_line.grp * 10) / 10) > 0) ? top_line.total / (Math.round(top_line.grp * 10) / 10) : 0;
                    var cpm = ((Math.round(top_line.impressions * 10) / 10) > 0) ? top_line.total / ((Math.round(top_line.impressions * 10) / 10) /div) : 0;

                    var perce_imp = 0;
                    if ((Math.round(parseFloat(top_line.imp_goal) * 10) / 10) > 0)
                        perce_imp = parseFloat(((Math.round(parseFloat(top_line.impressions) * 10) / 10) * 100) / (Math.round(parseFloat(top_line.imp_goal) * 10) / 10));

                    var perce = 0;
                    if ((Math.round(parseFloat(top_line.grp_goal) * 10) / 10) > 0)
                        perce = parseFloat(((Math.round(parseFloat(top_line.grp) * 10) / 10) * 100) / (Math.round(parseFloat(top_line.grp_goal) * 10) / 10));

                    for(var ind in secondary_demos){
                        sec_demos_array['cpp_'+ ind] = ((Math.round(top_line['grp_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / (Math.round(top_line['grp_'+ ind] * 10) / 10) : 0;
                        sec_demos_array['cpp_goal_'+ ind] = ((Math.round(sec_demos_array['grp_goal_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / (Math.round(sec_demos_array['grp_goal_'+ ind] * 10) / 10) : 0;

                        sec_demos_array['cpm_'+ ind] = ((Math.round(top_line['impressions_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / ((Math.round(top_line['impressions_'+ ind] * 10) / 10) / div) : 0;
                        sec_demos_array['cpm_goal_'+ ind] = ((Math.round(sec_demos_array['imp_goal_' + ind] * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / ((Math.round(sec_demos_array['imp_goal_' + ind] * 10) / 10) / div) : 0;

                        sec_demos_array['perce_imp_'+ ind] = 0;
                        if ((Math.round(parseFloat(sec_demos_array['imp_goal_' + ind]) * 10) / 10) > 0)
                            sec_demos_array['perce_imp_'+ ind] = parseFloat(((Math.round(parseFloat(top_line['impressions_' + ind]) * 10) / 10) * 100) / (Math.round(parseFloat(sec_demos_array['imp_goal_' + ind]) * 10) / 10));

                        sec_demos_array['perce_'+ ind] = 0;
                        if ((Math.round(parseFloat(sec_demos_array['grp_goal_' + ind]) * 10) / 10) > 0)
                            sec_demos_array['perce_'+ ind] = parseFloat(((Math.round(parseFloat(top_line['grp_'+ ind]) * 10) / 10) * 100) / (Math.round(parseFloat(sec_demos_array['grp_goal_' + ind]) * 10) / 10));
                    }

                    html += '<tr style="background-color:white">' +
                        '<td style="padding-left: 1% ;color:white" colspan="2"><b></b> </td>' +
                        '<td colspan="'+ network_column_colspan +'"></td>' +
                        '<td colspan="4" style="border-right: 1px solid black"></td>';

                    //Main demo top line
                    if (metrics.indexOf('grp') !== -1) {
                        html += '<td  style="color: black "><b>' + parseFloat(top_line.grp_goal).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style=" ' + border + 'color: black"><b>' + parseFloat(cpp_goal).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        html += '<td  style="color: black"><b>' + parseFloat(top_line.imp_goal).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style="color: black ;border-right: 1px solid black;"><b>' + parseFloat(cpm_goal).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('grp') !== -1) {
                        html += '<td  style="color: black;"><b>' + parseFloat(top_line.grp).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style="' + border + ' color: black"><b>' + parseFloat(cpp).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        html += '<td  style=" color: black"><b>' + parseFloat(top_line.impressions).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + ' </b></td>' +
                            '<td  style="border-right: 1px solid black; color: black"><b>' + parseFloat(cpm).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('grp') !== -1) {
                        var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                        html += '<td  style="color: black ; '+ b_lef_imp +'"><b>' + parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> %</td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-right: 1px solid black' : '';
                        html += '<td  style="color: black ; '+ b_lef_imp +'"><b>' + parseFloat(perce_imp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> %</td>';
                    }
                    //Sec demos top line
                    for(var ind in secondary_demos){
                        if (metrics.indexOf('grp') !== -1) {
                            html += '<td  style="color: black "><b>' + parseFloat(sec_demos_array['grp_goal_'+ ind]).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + '</b> </td>' +
                                '<td  style=" ' + border + 'color: black"><b>' + parseFloat(sec_demos_array['cpp_goal_'+ ind]).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }) + '</b> </td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            html += '<td  style="color: black"><b>' + parseFloat(sec_demos_array['imp_goal_'+ ind]).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + '</b> </td>' +
                                '<td  style="color: black ;border-right: 1px solid black;"><b>' + parseFloat(sec_demos_array['cpm_goal_'+ ind]).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }) + '</b> </td>';
                        }
                        if (metrics.indexOf('grp') !== -1) {
                            html += '<td  style="color: black; "><b>' + parseFloat(top_line['grp_' + ind]).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + '</b> </td>' +
                                '<td  style="' + border + ' color: black"><b>' + parseFloat(sec_demos_array['cpp_'+ ind]).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }) + '</b> </td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            html += '<td  style="color: black"><b>' + parseFloat(top_line['impressions_' + ind]).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + ' </b></td>' +
                                '<td  style="border-right: 1px solid black; color: black"><b>' + parseFloat(sec_demos_array['cpm_goal_'+ ind]).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2
                                }) + '</b> </td>';
                        }
                        if (metrics.indexOf('grp') !== -1) {
                            var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                            html += '<td  style="color: black; '+ b_lef_imp +'"><b>' + parseFloat(sec_demos_array['perce_'+ ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> %</td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-right: 1px solid black' : '';
                            html += '<td  style="color: black; '+ b_lef_imp+' "><b>' + parseFloat(sec_demos_array['perce_imp_'+ ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> %</td>';
                        }
                    }

                    html += '</tr>';
                }
                cont_index++;

                //STATION TOTAL LINE DETAIL
                top_line = station_totals[v_name];

                top_line.grp_goal = (typeof stations_values[v_name] !== 'undefined' && typeof stations_values[v_name]['total'] !== 'undefined') ? stations_values[v_name]['total'][2] : 0;
                top_line.imp_goal = (typeof stations_values[v_name] !== 'undefined' && typeof stations_values[v_name]['total'] !== 'undefined') ? stations_values[v_name]['total'][3] : 0;
                top_line.total_goal = (typeof stations_values[v_name] !== 'undefined' && typeof stations_values[v_name]['total'] !== 'undefined') ? stations_values[v_name]['total'][1] : 0;

                var sec_demos_array = [];
                for(var ind in secondary_demos) {
                    if (typeof sec_demos_array['imp_goal_' + ind] === 'undefined') {
                        sec_demos_array['imp_goal_' + ind] = 0;
                        sec_demos_array['grp_goal_' + ind] = 0;
                    }
                    if(typeof stations_values[v_name] !== 'undefined' && typeof stations_values[v_name]['total'] !== 'undefined') {
                        sec_demos_array['imp_goal_' + ind] += stations_values[v_name]['total']['sec_demos'][ind]['imp'];
                        sec_demos_array['grp_goal_' + ind] += stations_values[v_name]['total']['sec_demos'][ind]['rat'];
                    }
                }

                var cpp = ((Math.round(top_line.grp * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / (Math.round(top_line.grp * 10) / 10) : 0;
                var cpp_goal = ((Math.round(top_line.grp_goal * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / (Math.round(top_line.grp_goal * 10) / 10) : 0;

                var div = (report.type == 'msa') ? 10 : 1;
                var cpm = ((Math.round(top_line.impressions * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / ((Math.round(top_line.impressions * 10) / 10) / div) : 0;
                var cpm_goal = ((Math.round(top_line.imp_goal * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / ((Math.round(top_line.imp_goal * 10) / 10) / div) : 0;

                var perce_imp = 0;
                if ((Math.round(parseFloat(top_line.imp_goal) * 10) / 10) > 0)
                    perce_imp = parseFloat(((Math.round(parseFloat(top_line.impressions) * 10) / 10) * 100) / (Math.round(parseFloat(top_line.imp_goal) * 10) / 10));

                var perce = 0;
                if ((Math.round(parseFloat(top_line.grp_goal) * 10) / 10) > 0)
                    perce = parseFloat(((Math.round(parseFloat(top_line.grp) * 10) / 10) * 100) / (Math.round(parseFloat(top_line.grp_goal) * 10) / 10));

                for(var ind in secondary_demos){
                    sec_demos_array['cpp_'+ ind] = ((Math.round(top_line['grp_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / (Math.round(top_line['grp_'+ ind] * 10) / 10) : 0;
                    sec_demos_array['cpp_goal_'+ ind] = ((Math.round(sec_demos_array['grp_goal_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / (Math.round(sec_demos_array['grp_goal_'+ ind] * 10) / 10) : 0;

                    sec_demos_array['cpm_'+ ind] = ((Math.round(top_line['impressions_'+ ind] * 10) / 10) > 0) ? (Math.round(top_line.total * 10) / 10) / ((Math.round(top_line['impressions_'+ ind] * 10) / 10) / div) : 0;
                    sec_demos_array['cpm_goal_'+ ind] = ((Math.round(sec_demos_array['imp_goal_' + ind] * 10) / 10) > 0) ? (Math.round(top_line.total_goal * 10) / 10) / ((Math.round(sec_demos_array['imp_goal_' + ind] * 10) / 10) / div) : 0;

                    sec_demos_array['perce_imp_'+ ind] = 0;
                    if ((Math.round(parseFloat(sec_demos_array['imp_goal_' + ind]) * 10) / 10) > 0)
                        sec_demos_array['perce_imp_'+ ind] = parseFloat(((Math.round(parseFloat(top_line['impressions_' + ind]) * 10) / 10) * 100) / (Math.round(parseFloat(sec_demos_array['imp_goal_' + ind]) * 10) / 10));

                    sec_demos_array['perce_'+ ind] = 0;
                    if ((Math.round(parseFloat(sec_demos_array['grp_goal_' + ind]) * 10) / 10) > 0)
                        sec_demos_array['perce_'+ ind] = parseFloat(((Math.round(parseFloat(top_line['grp_'+ ind]) * 10) / 10) * 100) / (Math.round(parseFloat(sec_demos_array['grp_goal_' + ind]) * 10) / 10));
                }

                html += '<tr style="background-color:#848484">' +
                    '<td style="padding-left: 10px ;color:white" colspan="2"><b>Station: ' + v_name + '</b> </td>' +
                    '<td colspan="' + network_column_colspan +'"></td>' +
                    '<td colspan="4" style="border-right: 1px solid black"></td>' +
                    '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                    '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                    '<td colspan="' + colspan_1 + '" style="border-right: 1px solid black"></td>' ;

                //Sec Demos
                for (var ind in secondary_demos) {
                   html += '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                    '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                    '<td colspan="' + colspan_1 + '" style="border-right: 1px solid black"></td>' ;
                }
                html +=  '</tr>';

                html += '<tr style="background-color:white">' +
                    '<td style="padding-left: 1% ;color:black" colspan="2"><b></b> </td>' +
                    '<td colspan="' + network_column_colspan + '"></td>' +
                    '<td colspan="4" style="border-right: 1px solid black"></td>';

                //Station top line main demo
                if (metrics.indexOf('grp') !== -1) {
                    html += '<td  style="color: black "><b>' + parseFloat(top_line.grp_goal).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> </td>' +
                        '<td  style=" ' + border + 'color: black"><b>' + parseFloat(cpp_goal).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }) + '</b> </td>';
                }
                if (metrics.indexOf('impressions') !== -1) {
                    html += '<td  style="color: black"><b>' + parseFloat(top_line.imp_goal).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> </td>' +
                        '<td  style="color: black ;border-right: 1px solid black;"><b>' + parseFloat(cpm_goal).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }) + '</b> </td>';
                }
                if (metrics.indexOf('grp') !== -1) {
                    html += '<td  style="color: black;"><b>' + parseFloat(top_line.grp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> </td>' +
                        '<td  style="' + border + ' color: black"><b>' + parseFloat(cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }) + '</b> </td>';
                }
                if (metrics.indexOf('impressions') !== -1) {
                    html += '<td  style="color: black"><b>' + parseFloat(top_line.impressions).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + ' </b></td>' +
                        '<td  style="border-right: 1px solid black; color: black"><b>' + parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }) + '</b> </td>';
                }
                if (metrics.indexOf('grp') !== -1) {
                    var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                    html += '<td  style="color: black; '+ b_lef_imp +' "><b>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '</b> %</td>';
                }
                if (metrics.indexOf('impressions') !== -1) {
                    html += '<td  style="color: black; border-right: 1px solid black "><b>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }) + '</b> %</td>';
                }

                //Station top line seconday demos
                for(var ind in secondary_demos){
                    if (metrics.indexOf('grp') !== -1) {
                        html += '<td  style="color: black "><b>' + parseFloat(sec_demos_array['grp_goal_'+ ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style=" ' + border + 'color: black"><b>' + parseFloat(sec_demos_array['cpp_goal_'+ ind]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        html += '<td  style="color: black"><b>' + parseFloat(sec_demos_array['imp_goal_'+ ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style="color: black ;border-right: 1px solid black;"><b>' + parseFloat(sec_demos_array['cpm_goal_'+ ind]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('grp') !== -1) {
                        html += '<td  style="color: black; "><b>' + parseFloat(top_line['grp_' + ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + '</b> </td>' +
                            '<td  style="' + border + ' color: black"><b>' + parseFloat(sec_demos_array['cpp_'+ ind]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        html += '<td  style="color: black"><b>' + parseFloat(top_line['impressions_' + ind]).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + ' </b></td>' +
                            '<td  style="border-right: 1px solid black; color: black"><b>' + parseFloat(sec_demos_array['cpm_goal_'+ ind]).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                            }) + '</b> </td>';
                    }
                    if (metrics.indexOf('grp') !== -1) {
                        var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                        html += '<td  style="color: black; '+ b_lef_imp +'"><b>' + parseFloat(sec_demos_array['perce_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> %</td>';
                    }
                    if (metrics.indexOf('impressions') !== -1) {
                        var b_lef_imp = (metrics.indexOf('impressions') !== -1) ? 'border-right: 1px solid black' : '';
                        html += '<td  style="color: black; '+ b_lef_imp+' "><b>' + parseFloat(sec_demos_array['perce_imp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }) + '</b> %</td>';
                    }
                }

                html += '</tr>';
                for (var date in data) {
                    html += '<tr style="background-color:#eaeaea">' +
                        '<td style="padding-left: 10px ;color:black" colspan="2"><b>' + dates_of_week[date] + '</b>  <b>' + moment(date).format('MM/DD/YYYY') + '</b></td>' +
                        '<td colspan=" '+ network_column_colspan +'"></td>' +
                        '<td colspan="4" style="border-right: 1px solid black"></td>' +
                        '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                        '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                        '<td colspan="' + colspan_1 + '" style="border-right: 1px solid black"></td>' ;

                    for (var ind in secondary_demos) {
                         html += '<td colspan="' + colspan + '" style="border-right: 1px solid black; border-left: 1px solid black;"></td>' +
                          '<td colspan="' + colspan + '" style="border-right: 1px solid black"></td>' +
                          '<td colspan="' + colspan_1 + '" style="border-right: 1px solid black"></td>' ;
                    }
                    html += '</tr>';
                    var x = 1;
                    for (var i in data[date]) {
                        spots++;
                        total_gross += parseFloat(data[date][i].rate);
                        var string = '';
                        string = 'border-bottom:1px dotted grey';
                        html += '<tr style=" border-bottom: 1px dotted grey;  ">' +
                            '<td colspan="3" style="padding-left: 30px; border-bottom:1px dotted grey; white-space: nowrap; ">' + data[date][i].run_time + ' ' + data[date][i].line_days + ' ' + data[date][i].line_time + '</td>' ;
                        if(network_column_colspan === 3)
                           html +=    '<td  style=" border-bottom: 1px dotted grey">' + data[date][i].network + ' </td>' ;

                        html += '<td  style=" border-bottom: 1px dotted grey">' + data[date][i].program + ' </td>' +
                            '<td  style="border-bottom: 1px dotted grey">$' + data[date][i].rate + ' </td>' +
                            '<td  style=" border-bottom: 1px dotted grey">:' + data[date][i].length + ' </td>' +
                            '<td  style="border-bottom: 1px dotted grey">' + data[date][i].copy_id + ' </td>' +
                            '<td  style="border-right: 1px solid black; border-bottom:1px dotted grey">' + moment(data[date][i].week).format('MM/DD/YYYY') + ' </td>';

                        var perce_imp = 0;
                        if ((Math.round(parseFloat(data[date][i].old_impressions) * 10) / 10) > 0)
                            perce_imp = parseFloat(((Math.round(parseFloat(data[date][i].real_impressions.toFixed(1)) * 10) / 10) * 100) / (Math.round(parseFloat(data[date][i].old_impressions) * 10) / 10));

                        var perce = 0;
                        if ((Math.round(parseFloat(data[date][i].old_rating) * 10) / 10) > 0)
                            perce = parseFloat(((Math.round(parseFloat(data[date][i].real_rating) * 10) / 10) * 100) / (Math.round(parseFloat(data[date][i].old_rating) * 10) / 10));

                        if (metrics.indexOf('grp') !== -1) {
                            html += '<td  style=" border-bottom: 1px dotted grey">' + data[date][i].old_rating.toFixed(1) + ' </td>' +
                                '<td  style=" ' + border + ' border-bottom: 1px dotted grey">$' + data[date][i].old_cpp.toFixed(2) + ' </td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i].old_impressions.toFixed(1) + ' </td>' +
                                '<td  style="border-bottom: 1px dotted grey ;border-right: 1px solid black;">$' + data[date][i].old_cpm.toFixed(2) + ' </td>';
                        }
                        if (metrics.indexOf('grp') !== -1) {
                            html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i].real_rating.toFixed(1) + ' </td>' +
                                '<td  style="' + border + 'border-bottom: 1px dotted grey">$' + data[date][i].real_cpp.toFixed(2) + ' </td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i].real_impressions.toFixed(1) + ' </td>' +
                                '<td  style="border-bottom: 1px dotted grey ;border-right: 1px solid black">$' + data[date][i].real_cpm.toFixed(2) + ' </td>';
                        }
                        var ss = border !== '' ? border +';' : '';
                        if (metrics.indexOf('grp') !== -1) {
                            var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                            html += '<td  style=" ' + ss + '; border-bottom: 1px dotted grey; '+ b_lef_imp +'">' + parseFloat(perce).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + ' %</td>';
                        }
                        if (metrics.indexOf('impressions') !== -1) {
                            html += '<td  style=" ' + ss + ' border-bottom: 1px dotted grey; border-right: 1px solid black">' + parseFloat(perce_imp).toLocaleString("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }) + ' %</td>';
                        }
                        for(var ind in secondary_demos){
                            var perce_imp = 0;
                            if ((Math.round(parseFloat(data[date][i]['old_impressions_' + ind]) * 10) / 10) > 0)
                                perce_imp = parseFloat(((Math.round(parseFloat(data[date][i]['real_impressions_'+ ind].toFixed(1)) * 10) / 10) * 100) / (Math.round(parseFloat(data[date][i]['old_impressions_'+ ind]) * 10) / 10));

                            var perce = 0;
                            if ((Math.round(parseFloat(data[date][i]['old_rating_' + ind]) * 10) / 10) > 0)
                                perce = parseFloat(((Math.round(parseFloat(data[date][i]['real_rating_'+ ind]) * 10) / 10) * 100) / (Math.round(parseFloat(data[date][i]['old_rating_'+ ind]) * 10) / 10));

                            if (metrics.indexOf('grp') !== -1) {
                                html += '<td  style=" border-bottom: 1px dotted grey">' + data[date][i]['old_rating_' + ind].toFixed(1) + ' </td>' +
                                    '<td  style=" ' + border + ' border-bottom: 1px dotted grey">$' + data[date][i]['old_cpp_' + ind].toFixed(2) + ' </td>';
                            }
                            if (metrics.indexOf('impressions') !== -1) {
                                html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i]['old_impressions_' + ind].toFixed(1) + ' </td>' +
                                    '<td  style="border-bottom: 1px dotted grey ;border-right: 1px solid black;">$' + data[date][i]['old_cpm_' + ind].toFixed(2) + ' </td>';
                            }
                            if (metrics.indexOf('grp') !== -1) {
                                html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i]['real_rating_'+ ind].toFixed(1) + ' </td>' +
                                    '<td  style="' + border + ' border-bottom: 1px dotted grey">$' + data[date][i]['real_cpp_' + ind].toFixed(2) + ' </td>';
                            }
                            if (metrics.indexOf('impressions') !== -1) {
                                html += '<td  style="border-bottom: 1px dotted grey">' + data[date][i]['real_impressions_'+ ind].toFixed(1) + ' </td>' +
                                    '<td  style="border-bottom: 1px dotted grey ;border-right: 1px solid black">$' + data[date][i]['real_cpm_' + ind].toFixed(2) + ' </td>';
                            }
                            if (metrics.indexOf('grp') !== -1) {
                                var b_lef_imp = (metrics.indexOf('impressions') === -1) ? 'border-right: 1px solid black' : '';
                                html += '<td  style=" ' + border + ' border-bottom: 1px dotted grey; '+ b_lef_imp +'">' + parseFloat(perce).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + ' %</td>';
                            }
                            if (metrics.indexOf('impressions') !== -1)
                                html += '<td  style=" ' + border + ' border-bottom: 1px dotted grey; border-right: 1px solid black">' + parseFloat(perce_imp).toLocaleString("en-US", {
                                    style: "decimal",
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1,
                                }) + ' %</td>';
                        }

                        html += '</tr>';
                        rating_total += (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? parseFloat(data[date][i].real_rating.toFixed(1)) : 0);
                        if (last_rating !== -1)
                            rating_diff_total += (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? Math.abs(parseFloat(data[date][i].real_rating.toFixed(1)) - last_rating) : 0);
                        last_rating = (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? parseFloat(data[date][i].real_rating.toFixed(1)) : 0);
                        x++;
                    }
                }
            }
            html += '</table>';

            $('.report-content').html('');
            $('.report-content').html(html);

           // $('#html_totals').val(html_totals_send);
            $('#report_id').val(report.id);
            $('#dates_of_week').val(dates_of_week);
        }
        $('.export-pdf').on('click', function () {
            $('#export_pdf_post')
            $('#export_pdf_post').submit();
        });

        $('.export-excel').on('click', function () {
            var tables_to_export_excel = '';
            var cont = 0;
            var stations_names = '';
            for (var vnd_id in result) {
                var data = result[vnd_id];
                var v_name = '';
                var station = [];
                if (typeof vendor[vnd_id] !== 'undefined') {
                    v_name = vendor[vnd_id][0].name;
                    station = vendor[vnd_id][0];
                    if(cont === 0)
                        stations_names = v_name;
                    else
                        stations_names += ', '+v_name;
                    cont++;
                }
            }


            tables_to_export_excel += ' <table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>' +
                '<table style="width: 100%; font-size: 12px; "> ' +
                '<tr>' +
                '<td colspan="10" style="width: 100%; text-align: left">Post Buy Analysis </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Station(s): </td>' +
                '<td colspan="8" style="width: 60%;">' + stations_names + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Advertiser: </td>' +
                '<td colspan="8" style="width: 60%;">' + campaign.advertiser_name + ' </td>' +
                '</tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Campaign: </td>' +
                '<td colspan="8" style="width: 60%;">' + campaign.name + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Buyer: </td>' +
                '<td colspan="8" style="width: 60%;">' + user.name + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Post Dates: </td>' +
                '<td colspan="8" style="width: 60%;">' + campaign.date_range + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Agency: </td>' +
                '<td colspan="8" style="width: 60%;">' + agency.name + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Market: </td>' +
                '<td colspan="8" style="width: 60%;text-align:left ">'+ report_market.type.toUpperCase() +' - ' + report_market.name + ' </td>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="2" style="width: 15%; text-align: left">Report Type: </td>' +
                '<td colspan="8" style="width: 60%;text-align:left ">'+ report_type + ' vs Actual </td>' +
                '</tr>' +
                '</table>';

            tables_to_export_excel += '</table><table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>';
            tables_to_export_excel += '</table><table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>';
            tables_to_export_excel += $('.report-content').html();


            var a = document.createElement('a');
            var data_type = 'data:application/vnd.ms-excel';
            a.href = data_type + ', ' + encodeURIComponent(tables_to_export_excel);
            a.download = 'exported_' + moment().format('MM-DD-YYYY')  + '.xls';
            //triggering the function
            a.click();
            return false;
        });

        $('.export-csv').on('click', function () {
            var tables_to_export_excel = '';
            var cont = 0;
            for (var vnd_id in result) {
                var data = result[vnd_id];
                var v_name = '';
                var station = [];
                if (typeof vendor[vnd_id] !== 'undefined') {
                    v_name = vendor[vnd_id][0].name;
                    station = vendor[vnd_id][0];
                }
                if (cont > 0)
                    tables_to_export_excel += '</table><table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>';
                cont++;
                tables_to_export_excel += ' <table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>' +
                    '<table style="width: 100%; font-size: 12px; border-top: 1px solid black; border-bottom: 1px solid black; "> <tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Station: </td>' +
                    '<td colspan="4" style="width: 60%;">' + v_name + ' </td>' +
                    '<td colspan="2"></td> ' +
                    '<td colspan="4" style=" border-bottom: 1px double #678CB1; text-align: center" >Station Contact </td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Advertiser: </td>' +
                    '<td colspan="4" style="width: 60%;">' + campaign.advertiser_name + ' </td>' +
                    '<td colspan="2"></td> ' +
                    '<td colspan="4">  Name: ' + v_name + '</td>' +

                    '</tr>' +
                    '<tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Buyer: </td>' +
                    '<td colspan="4" style="width: 60%;">' + user.name + ' </td>' +
                    '<td colspan="2"></td> ' +
                    '<td colspan="4"> Phone: ' + station.contact_phone + ' </td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Post Dates: </td>' +
                    '<td colspan="4" style="width: 60%;">' + campaign.date_range + ' </td>' +
                    '<td colspan="2"></td> ' +
                    '<td colspan="4">  Fax: ' + station.contact_fax + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Agency: </td>' +
                    '<td colspan="4" style="width: 60%;">' + agency.name + ' </td>' +
                    '<td colspan="2"></td> ' +
                    '<td colspan="4">  Email: ' + station.contact_email + '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="2" style="width: 15%; text-align: left">Estimate #: </td>' +
                    '<td colspan="4" style="width: 60%;text-align:left ">' + campaign.estimate_number + ' </td>' +
                    '<td colspan="6"></td> ' +
                    '</tr></table>';
                //  '<table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>';

                tables_to_export_excel +=  $('.report-content').html();
            }
            var url = 'data:application/vnd.ms-csv,' + encodeURIComponent(tables_to_export_excel);
            location.href = url;
            return false;
        });

        //station summary
        columnStationBreakout = [
            {
                headerName: "Station",
                field: 'station',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Week",
                field: 'week',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRenderer,
            },
            {
                headerName: "Day",
                field: 'day',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Time",
                field: 'time',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Days",
                field: 'line_days',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Time",
                field: 'line_time',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Program",
                field: 'program',
                width: 130,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Vendor id",
                field: 'vendor_id',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "SL",
                field: 'len',
                width: 60,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Ads " + report_type,
                field: 'ads_ordered',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Gross Cost " + report_type,
                field: 'gross_ordered',
                width: 150,
                cellStyle: {'text-align': "right"},
            },
            {
                headerName: "Ads Approved",
                field: 'ads',
                width: 120,
                cellStyle: {'text-align': "center"},
            },
            {
                headerName: "Gross Cost Approved",
                field: 'total',
                width: 150,
                cellStyle: {'text-align': "right"},
            },

            // {
            //     headerName: report_type,
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'adjusted',
            //     children: [
            //         {
            //             headerName: "Ads "+ report_type,
            //             field: 'ads_ordered',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost " + report_type,
            //             field: 'gross_ordered',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP "+ report_type,
            //             field: 'grp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "CPP " + report_type,
            //             field: 'cpp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: imp_type + " "+ report_type,
            //             field: 'imp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM " + report_type,
            //             field: 'cpm_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //     ]
            // },
            // {
            //     headerName: "Delivered ",
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'delivered',
            //     children: [
            //         {
            //             headerName: "Ads Approved",
            //             field: 'ads',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost Approved",
            //             field: 'total',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP Delivered",
            //             field: 'grp',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP Delivered",
            //             field: 'cpp',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type + " Delivered",
            //             field: 'impressions',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM Delivered",
            //             field: 'cpm',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //
            //     ]
            // },
            // {
            //     headerName: "GRP Diff.",
            //     field: 'grp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: "GRP % Delivered ",
            //     field: 'grp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " Diff.",
            //     field: 'imp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " % Delivered ",
            //     field: 'imp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },

        ];
        columnWeekBreakout = [
            {
                headerName: "Week",
                field: 'week',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
                cellRenderer: MonthFormatRenderer,
            },
            {
                headerName: "Station",
                field: 'station',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Day",
                field: 'day',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Time",
                field: 'time',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Days",
                field: 'line_days',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Time",
                field: 'line_time',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Program",
                field: 'program',
                width: 130,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Vendor id",
                field: 'vendor_id',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "SL",
                field: 'len',
                width: 60,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            // {
            //     headerName: report_type,
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'adjusted',
            //     children: [
            //         {
            //             headerName: "Ads " + report_type,
            //             field: 'ads_ordered',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost " + report_type,
            //             field: 'gross_ordered',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP " + report_type,
            //             field: 'grp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP " + report_type,
            //             field: 'cpp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type +" " +report_type,
            //             field: 'imp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM " + report_type,
            //             field: 'cpm_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //
            //     ]
            // },
            // {
            //     headerName: "Delivered ",
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'delivered',
            //     children: [
            //         {
            //             headerName: "Ads Approved",
            //             field: 'ads',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost Approved",
            //             field: 'total',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP Delivered",
            //             field: 'grp',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP Delivered",
            //             field: 'cpp',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type + " Delivered",
            //             field: 'impressions',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM Delivered",
            //             field: 'cpm',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //
            //     ]
            // },
            // {
            //     headerName: "GRP Diff.",
            //     field: 'grp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: "GRP % Delivered ",
            //     field: 'grp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " Diff.",
            //     field: 'imp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type +" % Delivered ",
            //     field: 'imp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },

        ];
        columnDPBreakout = [
            {
                headerName: "Buy Line",
                field: 'daypart',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Station",
                field: 'station',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Day",
                field: 'day',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Time",
                field: 'time',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Days",
                field: 'line_days',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Time",
                field: 'line_time',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Program",
                field: 'program',
                width: 130,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Vendor id",
                field: 'vendor_id',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            // {
            //     headerName: report_type,
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'adjusted',
            //     children: [
            //         {
            //             headerName: "Ads "+ report_type,
            //             field: 'ads_ordered',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost "+ report_type,
            //             field: 'gross_ordered',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP "+ report_type,
            //             field: 'grp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP " + report_type,
            //             field: 'cpp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type + " " + report_type,
            //             field: 'imp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM " + report_type,
            //             field: 'cpm_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //     ]
            // },
            // {
            //     headerName: "Delivered ",
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'delivered',
            //     children: [
            //         {
            //             headerName: "Ads Approved",
            //             field: 'ads',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost Approved",
            //             field: 'total',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP Delivered",
            //             field: 'grp',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP Delivered",
            //             field: 'cpp',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type +" Delivered",
            //             field: 'impressions',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM Delivered",
            //             field: 'cpm',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //
            //     ]
            // },
            // {
            //     headerName: "GRP Diff.",
            //     field: 'grp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: "GRP % Delivered ",
            //     field: 'grp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type +" Diff.",
            //     field: 'imp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " % Delivered ",
            //     field: 'imp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },

        ];
        columnDPCodeBreakout = [
            {
                headerName: "Daypart",
                field: 'daypart_code',
                width: 120,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 0,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Station",
                field: 'station',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 1,
                hide: true,
                suppressMovable: true,
            },
            {
                headerName: "Day",
                field: 'day',
                width: 130,
                cellStyle: {'text-align': "right"},
                rowGroupIndex: 2,
                hide: true,
                suppressMovable: true,
                pinned: 'left'
            },
            {
                headerName: "Time",
                field: 'time',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Days",
                field: 'line_days',
                width: 100,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Line Time",
                field: 'line_time',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Program",
                field: 'program',
                width: 130,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                headerName: "Vendor id",
                field: 'vendor_id',
                width: 120,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            // {
            //     headerName: report_type,
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'adjusted',
            //     children: [
            //         {
            //             headerName: "Ads " + report_type,
            //             field: 'ads_ordered',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost "+ report_type,
            //             field: 'gross_ordered',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP " + report_type,
            //             field: 'grp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP "+ report_type,
            //             field: 'cpp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type + " " + report_type,
            //             field: 'imp_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM " + report_type,
            //             field: 'cpm_goal',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //     ]
            // },
            // {
            //     headerName: "Delivered ",
            //     headerTooltip: "",
            //     headerClass: 'group-header',
            //     groupId: 'delivered',
            //     children: [
            //         {
            //             headerName: "Ads Approved",
            //             field: 'ads',
            //             width: 120,
            //             cellStyle: {'text-align': "center"},
            //         },
            //         {
            //             headerName: "Gross Cost Approved",
            //             field: 'total',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //         },
            //         {
            //             headerName: "GRP Delivered",
            //             field: 'grp',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPP Delivered",
            //             field: 'cpp',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('grp') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: imp_type + " Delivered",
            //             field: 'impressions',
            //             width: 150,
            //             cellStyle: {'text-align': "center"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //         {
            //             headerName: "CPM Delivered",
            //             field: 'cpm',
            //             width: 150,
            //             cellStyle: {'text-align': "right"},
            //             hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            //         },
            //     ]
            // },
            // {
            //     headerName: "GRP Diff.",
            //     field: 'grp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: "GRP % Delivered ",
            //     field: 'grp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('grp') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " Diff.",
            //     field: 'imp_diff',
            //     width: 120,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },
            // {
            //     headerName: imp_type + " % Delivered ",
            //     field: 'imp_perc',
            //     width: 150,
            //     cellStyle: {'text-align': "center"},
            //     hide: (metrics.indexOf('impressions') !== -1) ? false : true,
            // },

        ];

        //Main Demos
        var text = main_demo + ' (Main Demo)';
        var headerClass = typeof secondary_demos.length === 'undefined' ? 'main-demo-back-color-1' : 'group-header';
        var row_demos = {
            headerName: report_type + " " + text,
            headerTooltip: "",
            //headerClass: 'group-header',
            headerClass: headerClass,
            groupId: 'adjusted',
            children: [
                {
                    headerName: "GRP "+ report_type,
                    field: 'grp_goal',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: "CPP "+ report_type ,
                    field: 'cpp_goal',
                    width: 150,
                    cellStyle: {'text-align': "right"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: imp_type + " " + report_type ,
                    field: 'imp_goal',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
                {
                    headerName: "CPM " + report_type ,
                    field: 'cpm_goal',
                    width: 150,
                    cellStyle: {'text-align': "right"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
            ],
        };
        columnStationBreakout.push(row_demos);
        columnWeekBreakout.push(row_demos);
        columnDPBreakout.push(row_demos);
        columnDPCodeBreakout.push(row_demos);
        var row_demos = {
            headerName: "Delivered " + text,
            headerTooltip: "",
            //headerClass: 'group-header',
            headerClass: headerClass,
            groupId: 'delivered',
            children: [
                {
                    headerName: "GRP Delivered" ,
                    field: 'grp',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: "CPP Delivered" ,
                    field: 'cpp',
                    width: 150,
                    cellStyle: {'text-align': "right"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: imp_type + " Delivered" ,
                    field: 'impressions',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
                {
                    headerName: "CPM Delivered" ,
                    field: 'cpm',
                    width: 150,
                    cellStyle: {'text-align': "right"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
            ],
        };
        columnStationBreakout.push(row_demos);
        columnWeekBreakout.push(row_demos);
        columnDPBreakout.push(row_demos);
        columnDPCodeBreakout.push(row_demos);
        var row_demos = {
            headerName: "Diff. && Percent " + text,
            headerTooltip: "",
           // headerClass: 'group-header',
            headerClass: headerClass,
            groupId: 'difference' ,
            children: [
                {
                    headerName: "GRP Diff." ,
                    field: 'grp_diff',
                    width: 120,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: "GRP % Delivered ",
                    field: 'grp_perc',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('grp') !== -1) ? false : true,
                },
                {
                    headerName: imp_type + " Diff." ,
                    field: 'imp_diff',
                    width: 120,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
                {
                    headerName: imp_type + " % Delivered ",
                    field: 'imp_perc',
                    width: 150,
                    cellStyle: {'text-align': "center"},
                    hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                },
            ],
        };
        columnStationBreakout.push(row_demos);
        columnWeekBreakout.push(row_demos);
        columnDPBreakout.push(row_demos);
        columnDPCodeBreakout.push(row_demos);

        //Secondary Demos
        var i = 2;
        for(var ind in secondary_demos){
            var text = secondary_demos[ind][0].demo_source !== 'comscore' ? secondary_demos[ind][0].demo_type.toUpperCase() + '-' + secondary_demos[ind][0].demo_name : secondary_demos[ind][0].demo_name;
            var row_demos = {
                headerName: report_type + " " + text,
                headerTooltip: "",
                headerClass: 'main-demo-back-color-' + i,
                groupId: 'adjusted_' + text,
                children: [
                    {
                        headerName: "GRP "+ report_type,
                        field: 'grp_goal_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: "CPP "+ report_type ,
                        field: 'cpp_goal_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: imp_type + " " + report_type,
                        field: 'imp_goal_'+ ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                    {
                        headerName: "CPM " + report_type ,
                        field: 'cpm_goal_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                ],
            };
            columnStationBreakout.push(row_demos);
            columnWeekBreakout.push(row_demos);
            columnDPBreakout.push(row_demos);
            columnDPCodeBreakout.push(row_demos);
            var row_demos = {
                headerName: "Delivered " + text,
                headerTooltip: "",
                headerClass: 'main-demo-back-color-' + i,
                groupId: 'delivered_' + text,
                children: [
                    {
                        headerName: "GRP Delivered" ,
                        field: 'grp_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: "CPP Delivered",
                        field: 'cpp_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: imp_type + " Delivered",
                        field: 'impressions_'+ ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                    {
                        headerName: "CPM Delivered",
                        field: 'cpm_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "right"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                ],
            };
            columnStationBreakout.push(row_demos);
            columnWeekBreakout.push(row_demos);
            columnDPBreakout.push(row_demos);
            columnDPCodeBreakout.push(row_demos);
            var row_demos = {
                headerName: "Diff. && Percent " + text,
                headerTooltip: "",
                headerClass: 'main-demo-back-color-' + i,
                groupId: 'difference' ,
                children: [
                    {
                        headerName: "GRP Diff.",
                        field: 'grp_diff_' + ind,
                        width: 120,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: "GRP % Delivered " ,
                        field: 'grp_perc_'+ ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('grp') !== -1) ? false : true,
                    },
                    {
                        headerName: imp_type + " Diff." ,
                        field: 'imp_diff_'+ ind,
                        width: 120,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                    {
                        headerName: imp_type + " % Delivered ",
                        field: 'imp_perc_' + ind,
                        width: 150,
                        cellStyle: {'text-align': "center"},
                        hide: (metrics.indexOf('impressions') !== -1) ? false : true,
                    },
                ],
            };

            columnStationBreakout.push(row_demos);
            columnWeekBreakout.push(row_demos);
            columnDPBreakout.push(row_demos);
            columnDPCodeBreakout.push(row_demos);
            i = i === 2 ? 1 : 2;
        }

        gridCampBreakoutSta = {
            columnDefs: columnStationBreakout,
            autoGroupColumnDef: {
                headerName: 'Stations',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return StationBreakAggFunction(nodes, 'stations');
            },
            onGridReady: function (e) {

            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        gridCampBreakoutWeek = {
            columnDefs: columnWeekBreakout,
            autoGroupColumnDef: {
                headerName: 'Weeks',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return StationBreakAggFunction(nodes, 'weeks');
            },
            onGridReady: function (e) {

            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        gridCampBreakoutDP = {
            columnDefs: columnDPBreakout,
            autoGroupColumnDef: {
                headerName: 'Dayparts',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return StationBreakAggFunction(nodes, 'buy_line');
            },
            onGridReady: function (e) {

            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };
        gridCampBreakoutDPCode = {
            columnDefs: columnDPCodeBreakout,
            autoGroupColumnDef: {
                headerName: 'Dayparts',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                }
            },
            toolPanelSuppressValues: true,defaultToolPanel: '',
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 0,
            marryChildren: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            groupRowAggNodes: function (nodes) {
                return StationBreakAggFunction(nodes, 'dp_code');
            },
            onGridReady: function (e) {

            },
            icons: {
                groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
            onFilterChanged: function (e) {
                // totalInvDetailUpd(this);
                // if (this.api.isAnyFilterPresent())
                //     $('#reset_filters').show();
                // else
                //     $('#reset_filters').hide();
            },
        };

        function MonthFormatRenderer() {
        }
        MonthFormatRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('span');
            if (typeof params.value !== 'undefined') {
                if (params.node.rowPinned !== 'bottom') {
                    if (typeof params.value !== 'undefined' && params.value !== null && params.value !== '' && params.value !== -1) {
                        this.eGui.innerHTML = 'Week '+ moment(params.value).format('MMM DD, YYYY');
                    } else {
                        this.eGui.innerHTML = '';
                    }
                } else {
                    this.eGui.innerHTML = '';
                }
            } else {
                this.eGui.innerHTML = '';
            }
        };
        MonthFormatRenderer.prototype.getGui = function () {
            return this.eGui;
        };
        console.log('week_values: ', week_values);
        var StationBreakAggFunction = function (nodes, type) {
            var result = {};
            if (nodes[0] != undefined) {
                if (nodes[0].level === 2) {
                    result['ads'] = 0;
                    result['total'] = 0;
                    var grp_goal = 0;
                    var grp = 0;
                    var ads_ordered = 0;
                    var gross_ordered = 0;
                    var gri_goal = 0;
                    var gri = 0;
                    var imp_goal = 0;
                    var impressions = 0;
                    var grp_ordered = 0;
                    var gri_ordered = 0;
                    var array_sec = [];
                    for(var ind in secondary_demos){
                        array_sec['grp_goal_'+ ind ] = 0;
                        array_sec['grp_'+ ind ] = 0;
                        array_sec['imp_goal_'+ ind ] = 0;
                        array_sec['impressions_'+ ind ] = 0;
                        array_sec['gri_goal_'+ ind ] = 0;
                        array_sec['gri_'+ ind ] = 0;
                        array_sec['grp_ordered_'+ ind ] = 0;
                        array_sec['gri_ordered_'+ ind ] = 0;
                    }
                    $.each(nodes, function (index, value) {
                        $.each(value.childrenAfterGroup, function (index, value) {
                            grp_goal += parseFloat(value['data']['grp_goal']) * parseInt(value['data']['ads']);
                            grp += parseFloat(value['data']['grp']) * parseInt(value['data']['ads']);

                            gri_goal += parseFloat(value['data']['imp_goal']) * parseInt(value['data']['ads']);
                            gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);

                            imp_goal += parseFloat(value['data']['imp_goal']);
                            impressions += parseFloat(value['data']['impressions']) ;

                            for(var ind in secondary_demos){
                                array_sec['grp_goal_'+ ind ] += parseFloat(value['data']['grp_goal_'+ ind]) * parseInt(value['data']['ads']);
                                array_sec['grp_'+ ind ] += parseFloat(value['data']['grp_'+ ind]) * parseInt(value['data']['ads']);

                                array_sec['gri_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]) * parseInt(value['data']['ads']);
                                array_sec['gri_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) * parseInt(value['data']['ads']);

                                array_sec['imp_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]);
                                array_sec['impressions_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) ;
                            }

                            if(type == 'stations') {
                                var week = moment(value['data']['week']).format('YYYY-MM-DD');
                                if (typeof stations_values[value['data']['station']] !== 'undefined' && typeof stations_values[value['data']['station']][week] !== 'undefined'){
                                    ads_ordered = stations_values[value['data']['station']][week][0];
                                    gross_ordered = stations_values[value['data']['station']][week][1];
                                    grp_ordered =  stations_values[value['data']['station']][week][2] * stations_values[value['data']['station']][week][0];
                                    gri_ordered =  stations_values[value['data']['station']][week][3] * stations_values[value['data']['station']][week][0];

                                    for(var ind in secondary_demos) {
                                        array_sec['grp_ordered_' + ind] = stations_values[value['data']['station']][week]['sec_demos'][ind]['rat'] * stations_values[value['data']['station']][week][0];
                                        array_sec['gri_ordered_' + ind] = stations_values[value['data']['station']][week]['sec_demos'][ind]['imp'] * stations_values[value['data']['station']][week][0];
                                    }
                                }
                            }
                            if(type == 'weeks') {
                                var week = moment(value['data']['week']).format('YYYY-MM-DD');
                                if (typeof week_values[week] !== 'undefined' && typeof week_values[week][value['data']['station']]!== 'undefined'){
                                    ads_ordered = week_values[week][value['data']['station']][0];
                                    gross_ordered = week_values[week][value['data']['station']][1];
                                    grp_ordered =  week_values[week][value['data']['station']][0] * week_values[week][value['data']['station']][2];
                                    gri_ordered =  week_values[week][value['data']['station']][0] * week_values[week][value['data']['station']][3];

                                    for(var ind in secondary_demos) {
                                        array_sec['grp_ordered_' + ind] = week_values[week][value['data']['station']]['sec_demos'][ind]['rat'] * week_values[week][value['data']['station']][0];
                                        array_sec['gri_ordered_' + ind] = week_values[week][value['data']['station']]['sec_demos'][ind]['imp'] * week_values[week][value['data']['station']][0];
                                    }
                                }
                            }
                            if(type == 'dp_code'){
                                if (typeof dp_code_values[value['data']['daypart_code']] !== 'undefined' && typeof dp_code_values[value['data']['daypart_code']][value['data']['station']] !== 'undefined'){
                                    ads_ordered = dp_code_values[value['data']['daypart_code']][value['data']['station']][0];
                                    gross_ordered = dp_code_values[value['data']['daypart_code']][value['data']['station']][1];
                                    grp_ordered = dp_code_values[value['data']['daypart_code']][value['data']['station']][0] * dp_code_values[value['data']['daypart_code']][value['data']['station']][2];
                                    gri_ordered = dp_code_values[value['data']['daypart_code']][value['data']['station']][0] * dp_code_values[value['data']['daypart_code']][value['data']['station']][3];

                                    for(var ind in secondary_demos) {
                                        array_sec['grp_ordered_' + ind] = dp_code_values[value['data']['daypart_code']][value['data']['station']]['sec_demos'][ind]['rat'] * dp_code_values[value['data']['daypart_code']][value['data']['station']][0];
                                        array_sec['gri_ordered_' + ind] = dp_code_values[value['data']['daypart_code']][value['data']['station']]['sec_demos'][ind]['imp'] * dp_code_values[value['data']['daypart_code']][value['data']['station']][0];
                                    }
                                }
                            }
                            if(type == 'buy_line'){
                                if (typeof buy_line_values[value['data']['daypart']] !== 'undefined' && typeof buy_line_values[value['data']['daypart']][value['data']['station']] !== 'undefined'){
                                    ads_ordered = buy_line_values[value['data']['daypart']][value['data']['station']][0];
                                    gross_ordered = buy_line_values[value['data']['daypart']][value['data']['station']][1];
                                    grp_ordered = buy_line_values[value['data']['daypart']][value['data']['station']][0] * buy_line_values[value['data']['daypart']][value['data']['station']][2];
                                    gri_ordered = buy_line_values[value['data']['daypart']][value['data']['station']][0] * buy_line_values[value['data']['daypart']][value['data']['station']][3];

                                    for(var ind in secondary_demos) {
                                        array_sec['grp_ordered_' + ind] = buy_line_values[value['data']['daypart']][value['data']['station']]['sec_demos'][ind]['rat'] * buy_line_values[value['data']['daypart']][value['data']['station']][0];
                                        array_sec['gri_ordered_' + ind] = buy_line_values[value['data']['daypart']][value['data']['station']]['sec_demos'][ind]['imp'] * buy_line_values[value['data']['daypart']][value['data']['station']][0];
                                    }
                                }
                            }
                            $.each(value['data'], function (index, value) {
                                if (index in result) {
                                    if (typeof value !== 'undefined') {
                                        if (isNaN(value)) {
                                            var sum = value.replace('$', '');
                                            sum = sum.replace(/,/g, '') ;
                                            result[index] += parseFloat(sum)
                                        } else
                                            result[index] += parseFloat(value);
                                    }
                                }
                            });
                        });
                    });
                    grp_goal = grp_ordered;
                    gri_goal = gri_ordered;

                    for(var ind in secondary_demos) {
                        //Ratings part
                        array_sec['grp_goal_' + ind] = array_sec['grp_ordered_' + ind];
                        result['grp_goal_'+ ind] = array_sec['grp_goal_'+ ind];
                        result['grp_'+ ind] = array_sec['grp_'+ ind];
                        result['grp_diff_'+ ind] = parseFloat(result['grp_'+ ind]) - parseFloat(result['grp_goal_'+ ind]);
                        var perce = parseFloat(result['grp_goal_'+ ind]) > 0 ? parseFloat((parseFloat(result['grp_'+ ind]) * 100) / parseFloat(result['grp_goal_'+ ind])) : 0;

                        var cpp_ind = result['grp_' + ind] > 0 ? result['total'] / result['grp_' + ind] : 0;
                        result['cpp_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_'+ind] = parseFloat(result['grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_diff_' + ind] = parseFloat(result['grp_diff_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        var cpp_ind = result['grp_goal_' + ind] > 0 ? result['total'] / result['grp_goal_' + ind] : 0;
                        result['cpp_goal_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_goal_' + ind] = parseFloat(result['grp_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        result['grp_perc_' + ind] = parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';

                        //Impressions part
                       // array_sec['gri_goal_' + ind] = array_sec['gri_ordered_' + ind];
                        result['gri_'+ ind] = array_sec['gri_' + ind];
                        result['gri_goal_'+ ind] = array_sec['gri_ordered_' + ind];
                        result['impressions_'+ ind] = parseFloat(array_sec['impressions_' + ind]);
                        result['imp_goal_' + ind] = parseFloat(array_sec['imp_goal_' + ind]);
                        result['imp_diff'] = parseFloat(result['impressions_'+ ind]) - parseFloat(result['imp_goal_'+ ind]);

                        var imp_perce = parseFloat(result['imp_goal_' + ind]) ? parseFloat((parseFloat(result['impressions_'+ ind]) * 100) / parseFloat(result['imp_goal_'+ ind])) : 0;
                        result['imp_perc_'+ ind] = parseFloat(imp_perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';
                        result['imp_diff_'+ ind] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        var div  = (report.type == 'msa') ? 10 : 1;
                        var cpm = (result['gri_'+ ind]/ div) > 0 ?  result['total'] / (result['gri_'+ ind]/ div) : 0
                        result['cpm_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2
                        });

                        var cpm = (result['gri_goal_'+ ind]/ div) > 0 ?  gross_ordered / (result['gri_goal_'+ ind]/ div) : 0
                        result['cpm_goal_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['impressions_'+ ind] = parseFloat(result['impressions_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['imp_goal_'+ ind] = parseFloat(result['gri_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                    }
                    result['grp'] = parseFloat(grp);
                    result['grp_diff'] = parseFloat(grp) - parseFloat(grp_goal);

                    result['ads_ordered'] = ads_ordered;
                    result['gross_ordered'] = gross_ordered;

                    var perce = 0;
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['total'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_diff'] = parseFloat(result['grp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_goal'] = parseFloat(grp_goal);
                    if (result['grp_goal'] > 0) {
                        result['cpp_goal'] = parseFloat(result['gross_ordered'] / result['grp_goal']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        perce = parseFloat((parseFloat(grp) * 100) / parseFloat(grp_goal));
                    } else {
                        result['cpp_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp_goal'] = parseFloat(result['grp_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_perc'] = parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';

                    result['gri'] = parseFloat(gri);
                    result['gri_goal'] = parseFloat(gri_goal);
                    result['impressions'] = parseFloat(impressions);
                    result['imp_goal'] = parseFloat(imp_goal);
                    result['imp_diff'] = parseFloat(impressions) - parseFloat(imp_goal);
                    var imp_perce = 0;
                    if(parseFloat(imp_goal) > 0)
                        imp_perce = parseFloat((parseFloat(impressions) * 100) / parseFloat(imp_goal));

                    result['imp_perc'] = parseFloat(imp_perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';
                    result['imp_diff'] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    var div  = (report.type == 'msa') ? 10 : 1;
                    if (result['gri'] > 0) {
                        result['cpm'] = parseFloat(result['total'] / (result['gri']/ div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if (result['gri_goal'] > 0) {
                        result['cpm_goal'] = parseFloat(result['gross_ordered'] / (result['gri_goal'] / div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                    } else {
                        result['cpm_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['impressions'] = parseFloat(result['impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['imp_goal'] = parseFloat(result['gri_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['gross_ordered'] = parseFloat(gross_ordered).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['total'] = parseFloat(result['total']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    if (type === 'weeks')
                        console.log('result_level 2 ',type,  result);

                }
                else if (nodes[0].level === 1) {
                    result['ads'] = 0;
                    result['total'] = 0;
                    var grp_goal = 0;
                    var grp = 0;
                    var ads_ordered = 0;
                    var gross_ordered = 0;
                    var gri_ordered = 0;
                    var gri_goal = 0;
                    var gri_goal = 0;
                    var gri = 0;
                    var imp_goal = 0;
                    var impressions = 0;
                    var array_sec = [];
                    for(var ind in secondary_demos){
                        array_sec['grp_goal_'+ ind ] = 0;
                        array_sec['grp_'+ ind ] = 0;
                        array_sec['imp_goal_'+ ind ] = 0;
                        array_sec['impressions_'+ ind ] = 0;
                        array_sec['gri_goal_'+ ind ] = 0;
                        array_sec['gri_'+ ind ] = 0;
                        array_sec['grp_ordered_'+ ind ] = 0;
                        array_sec['gri_ordered_'+ ind ] = 0;
                    }

                    $.each(nodes, function (index, value) {
                        // nodes[index].expanded = true;
                        $.each(value.childrenAfterGroup, function (index, value) {
                            $.each(value.childrenAfterGroup, function (index, value) {
                                grp += parseFloat(value['data']['grp']) * parseInt(value['data']['ads']);
                                grp_goal += parseFloat(value['data']['grp_goal']) * parseInt(value['data']['ads']);

                                gri_goal += parseFloat(value['data']['imp_goal']) * parseInt(value['data']['ads']);
                                gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);

                                imp_goal += parseFloat(value['data']['imp_goal']);
                                impressions += parseFloat(value['data']['impressions']) ;

                                for(var ind in secondary_demos){
                                    array_sec['grp_goal_'+ ind ] += parseFloat(value['data']['grp_goal_'+ ind]) * parseInt(value['data']['ads']);
                                    array_sec['grp_'+ ind ] += parseFloat(value['data']['grp_'+ ind]) * parseInt(value['data']['ads']);

                                    array_sec['gri_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]) * parseInt(value['data']['ads']);
                                    array_sec['gri_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) * parseInt(value['data']['ads']);

                                    array_sec['imp_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]);
                                    array_sec['impressions_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) ;
                                }

                                if(type == 'stations') {
                                    if (typeof stations_values[value['data']['station']] !== 'undefined' ){
                                        ads_ordered = stations_values[value['data']['station']]['total'][0];
                                        gross_ordered = stations_values[value['data']['station']]['total'][1];
                                        grp_ordered = stations_values[value['data']['station']]['total'][2] ;
                                        gri_ordered = stations_values[value['data']['station']]['total'][3] ;

                                        for(var ind in secondary_demos) {
                                            array_sec['grp_ordered_' + ind] = stations_values[value['data']['station']]['total']['sec_demos'][ind]['rat'];
                                            array_sec['gri_ordered_' + ind] = stations_values[value['data']['station']]['total']['sec_demos'][ind]['imp'] ;
                                        }
                                    }
                                }
                                if(type == 'weeks') {
                                    var week = moment(value['data']['week']).format('YYYY-MM-DD');
                                    console.log('WEEKS SHOWING: ',value['data']['week'], week)
                                    if (typeof week_values[week] !== 'undefined' ){
                                        ads_ordered = week_values[week]['total'][0];
                                        gross_ordered = week_values[week]['total'][1];
                                        grp_ordered = week_values[week]['total'][2];
                                        gri_ordered = week_values[week]['total'][3];

                                        for(var ind in secondary_demos) {
                                            array_sec['grp_ordered_' + ind] = week_values[week]['total']['sec_demos'][ind]['rat'];
                                            array_sec['gri_ordered_' + ind] = week_values[week]['total']['sec_demos'][ind]['imp'] ;
                                        }
                                    }
                                }
                                if(type == 'dp_code'){
                                    if (typeof dp_code_values[value['data']['daypart_code']] !== 'undefined' ){
                                        ads_ordered = dp_code_values[value['data']['daypart_code']]['total'][0];
                                        gross_ordered = dp_code_values[value['data']['daypart_code']]['total'][1];
                                        grp_ordered = dp_code_values[value['data']['daypart_code']]['total'][2];
                                        gri_ordered = dp_code_values[value['data']['daypart_code']]['total'][3];

                                        for(var ind in secondary_demos) {
                                            array_sec['grp_ordered_' + ind] = dp_code_values[value['data']['daypart_code']]['total']['sec_demos'][ind]['rat'];
                                            array_sec['gri_ordered_' + ind] = dp_code_values[value['data']['daypart_code']]['total']['sec_demos'][ind]['imp'] ;
                                        }

                                    }
                                }
                                if(type == 'buy_line'){
                                    if (typeof buy_line_values[value['data']['daypart']] !== 'undefined' ){
                                        ads_ordered = buy_line_values[value['data']['daypart']]['total'][0];
                                        gross_ordered = buy_line_values[value['data']['daypart']]['total'][1];
                                        grp_ordered = buy_line_values[value['data']['daypart']]['total'][2];
                                        gri_ordered = buy_line_values[value['data']['daypart']]['total'][3];

                                        for(var ind in secondary_demos) {
                                            array_sec['grp_ordered_' + ind] = buy_line_values[value['data']['daypart']]['total']['sec_demos'][ind]['rat'];
                                            array_sec['gri_ordered_' + ind] = buy_line_values[value['data']['daypart']]['total']['sec_demos'][ind]['imp'] ;
                                        }
                                    }
                                }
                                $.each(value['data'], function (index, value) {
                                    if (index in result) {
                                        if (typeof value !== 'undefined') {
                                            if (index == 'ads')
                                                result[index] += value;
                                            else {
                                                var sum = value.replace('$', '');
                                                sum = sum.replace(/,/g, '') ;
                                                result[index] += parseFloat(sum)

                                            }
                                        }
                                    }
                                });
                            });
                        });
                    });
                    grp_goal = grp_ordered;
                    gri_goal = gri_ordered;
                    for(var ind in secondary_demos) {
                        //Ratings part
                        array_sec['grp_goal_' + ind] = array_sec['grp_ordered_' + ind];
                        result['grp_goal_'+ ind] = array_sec['grp_goal_'+ ind];
                        result['grp_'+ ind] = array_sec['grp_'+ ind];
                        result['grp_diff_'+ ind] = parseFloat(result['grp_'+ ind]) - parseFloat(result['grp_goal_'+ ind]);
                        var perce = parseFloat(result['grp_goal_'+ ind]) > 0 ? parseFloat((parseFloat(result['grp_'+ ind]) * 100) / parseFloat(result['grp_goal_'+ ind])) : 0;

                        var cpp_ind = result['grp_' + ind] > 0 ? result['total'] / result['grp_' + ind] : 0;
                        result['cpp_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_'+ind] = parseFloat(result['grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_diff_' + ind] = parseFloat(result['grp_diff_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        var cpp_ind = result['grp_goal_' + ind] > 0 ? result['total'] / result['grp_goal_' + ind] : 0;
                        result['cpp_goal_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_goal_' + ind] = parseFloat(result['grp_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        result['grp_perc_'+ ind] = parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';

                        //Impressions part
                        // array_sec['gri_goal_' + ind] = array_sec['gri_ordered_' + ind];
                        result['gri_'+ ind] = array_sec['gri_' + ind];
                        result['gri_goal_'+ ind] = array_sec['gri_ordered_' + ind];
                        result['impressions_'+ ind] = parseFloat(array_sec['impressions_' + ind]);
                        result['imp_goal_' + ind] = parseFloat(array_sec['imp_goal_' + ind]);
                        result['imp_diff'] = parseFloat(result['impressions_'+ ind]) - parseFloat(result['imp_goal_'+ ind]);

                        var imp_perce = parseFloat(result['imp_goal_' + ind]) ? parseFloat((parseFloat(result['impressions_'+ ind]) * 100) / parseFloat(result['imp_goal_'+ ind])) : 0;
                        result['imp_perc_'+ ind] = parseFloat(imp_perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';
                        result['imp_diff_'+ ind] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        var div  = (report.type == 'msa') ? 10 : 1;
                        var cpm = (result['gri_'+ ind]/ div) > 0 ?  result['total'] / (result['gri_'+ ind]/ div) : 0
                        result['cpm_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                        var cpm = (result['gri_goal_'+ ind]/ div) > 0 ?  gross_ordered / (result['gri_goal_'+ ind]/ div) : 0
                        result['cpm_goal_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['impressions_'+ ind] = parseFloat(result['impressions_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['imp_goal_'+ ind] = parseFloat(result['gri_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                    }

                    result['ads_ordered'] = ads_ordered;
                    result['gross_ordered'] = gross_ordered;

                    result['grp'] = parseFloat(grp);
                    result['grp_diff'] = parseFloat(grp) - parseFloat(grp_goal);
                    var perce = 0;
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['total'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_diff'] = parseFloat(result['grp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_goal'] = parseFloat(grp_goal);
                    if (result['grp_goal'] > 0) {
                        result['cpp_goal'] = parseFloat(result['gross_ordered'] / result['grp_goal']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        perce = parseFloat((parseFloat(grp) * 100) / parseFloat(grp_goal));
                    } else {
                        result['cpp_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp_goal'] = parseFloat(result['grp_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_perc'] = parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';

                    result['gri'] = parseFloat(gri);
                    result['gri_goal'] = parseFloat(gri_goal);
                    result['impressions'] = parseFloat(impressions);
                    result['imp_goal'] = parseFloat(imp_goal);
                    result['imp_diff'] = parseFloat(impressions) - parseFloat(imp_goal);

                    var imp_perce = 0;
                    if(parseFloat(imp_goal) > 0)
                        imp_perce = parseFloat((parseFloat(impressions) * 100) / parseFloat(imp_goal));

                    result['imp_perc'] = parseFloat(imp_perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';
                    result['imp_diff'] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    var div  = (report.type == 'msa') ? 10 : 1;
                    if (result['gri'] > 0) {
                        result['cpm'] = parseFloat(result['total'] / (result['gri'] / div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if (result['gri_goal'] > 0) {
                        result['cpm_goal'] = parseFloat(result['gross_ordered'] / (result['gri_goal'] / div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        perce = parseFloat((parseFloat(gri) * 100) / parseFloat(gri_goal));
                    } else {
                        result['cpm_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['impressions'] = parseFloat(result['impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['imp_goal'] = parseFloat(result['gri_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['gross_ordered'] = parseFloat(gross_ordered).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });

                    result['total'] = parseFloat(result['total']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    if (type === 'weeks')
                        console.log('level 1 results ', result);

                }
                else if (nodes[0].level === 3) {
                    result['ads'] = 0;
                    result['total'] = 0;
                    var grp = 0;
                    var grp_goal = 0;
                    var gri_goal = 0;
                    var gri = 0;
                    var imp_goal = 0;
                    var impressions = 0;
                    var array_sec = [];
                    for(var ind in secondary_demos){
                        array_sec['grp_goal_'+ ind ] = 0;
                        array_sec['grp_'+ ind ] = 0;
                        array_sec['imp_goal_'+ ind ] = 0;
                        array_sec['impressions_'+ ind ] = 0;
                        array_sec['gri_goal_'+ ind ] = 0;
                        array_sec['gri_'+ ind ] = 0;
                        array_sec['grp_ordered_'+ ind ] = 0;
                        array_sec['gri_ordered_'+ ind ] = 0;
                    }
                    $.each(nodes, function (index, value) {
                        grp += parseFloat(value['data']['grp']) * parseInt(value['data']['ads']);
                        grp_goal += parseFloat(value['data']['grp_goal']) * parseInt(value['data']['ads']);

                        gri_goal += parseFloat(value['data']['imp_goal']) * parseInt(value['data']['ads']);
                        gri += parseFloat(value['data']['impressions']) * parseInt(value['data']['ads']);

                        imp_goal += parseFloat(value['data']['imp_goal']);
                        impressions += parseFloat(value['data']['impressions']) ;


                        for(var ind in secondary_demos){
                            array_sec['grp_goal_'+ ind ] += parseFloat(value['data']['grp_goal_'+ ind]) * parseInt(value['data']['ads']);
                            array_sec['grp_'+ ind ] += parseFloat(value['data']['grp_'+ ind]) * parseInt(value['data']['ads']);

                            array_sec['gri_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]) * parseInt(value['data']['ads']);
                            array_sec['gri_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) * parseInt(value['data']['ads']);

                            array_sec['imp_goal_'+ ind ] += parseFloat(value['data']['imp_goal_'+ ind]);
                            array_sec['impressions_'+ ind ] += parseFloat(value['data']['impressions_'+ ind]) ;
                        }

                        $.each(value['data'], function (index, value) {
                            if (index in result) {
                                if (typeof value !== 'undefined') {
                                    if (index == 'ads')
                                        result[index] += value;
                                    else {
                                        var sum = value.replace('$', '');
                                        sum = sum.replace(/,/g, '') ;
                                        result[index] += parseFloat(sum);
                                    }
                                }
                            }
                        });
                    });

                    for(var ind in secondary_demos) {
                        //Ratings part
                        result['grp_goal_'+ ind] = array_sec['grp_goal_'+ ind];
                        result['grp_'+ ind] = array_sec['grp_'+ ind];
                        result['grp_diff_'+ ind] = parseFloat(result['grp_'+ ind]) - parseFloat(result['grp_goal_'+ ind]);
                        var perce = parseFloat(result['grp_goal_'+ ind]) > 0 ? parseFloat((parseFloat(result['grp_'+ ind]) * 100) / parseFloat(result['grp_goal_'+ ind])) : 0;

                        var cpp_ind = result['grp_' + ind] > 0 ? result['total'] / result['grp_' + ind] : 0;
                        result['cpp_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_'+ind] = parseFloat(result['grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['grp_diff_' + ind] = parseFloat(result['grp_diff_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        var cpp_ind = result['grp_goal_' + ind] > 0 ? result['total'] / result['grp_goal_' + ind] : 0;
                        result['cpp_goal_'+ind] = parseFloat(cpp_ind).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['grp_goal_' + ind] = parseFloat(result['grp_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        result['grp_perc_' + ind] = parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';

                        //Impressions part
                        result['gri_'+ ind] = array_sec['gri_' + ind];
                        result['gri_goal_'+ ind] = array_sec['gri_goal_' + ind];
                        result['impressions_'+ ind] = parseFloat(array_sec['impressions_' + ind]);
                        result['imp_goal_' + ind] = parseFloat(array_sec['imp_goal_' + ind]);
                        result['imp_diff'] = parseFloat(result['impressions_'+ ind]) - parseFloat(result['imp_goal_'+ ind]);

                        var imp_perce = parseFloat(result['imp_goal_' + ind]) ? parseFloat((parseFloat(result['impressions_'+ ind]) * 100) / parseFloat(result['imp_goal_'+ ind])) : 0;
                        result['imp_perc_'+ ind] = parseFloat(imp_perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })+ '%';
                        result['imp_diff_'+ ind] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                        var div  = (report.type == 'msa') ? 10 : 1;
                        var cpm = (result['gri_'+ ind]/ div) > 0 ?  result['total'] / (result['gri_'+ ind]/ div) : 0
                        result['cpm_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });

                        var cpm = (result['gri_goal_'+ ind]/ div) > 0 ?  gross_ordered / (result['gri_goal_'+ ind]/ div) : 0
                        result['cpm_goal_' + ind] = parseFloat(cpm).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        result['impressions_'+ ind] = parseFloat(result['impressions_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        result['imp_goal_'+ ind] = parseFloat(result['gri_goal_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });

                    }

                    result['grp'] = parseFloat(grp);
                    result['grp_diff'] = parseFloat(grp) - parseFloat(grp_goal);
                    var perce = 0;
                    if (result['grp'] > 0) {
                        result['cpp'] = parseFloat(result['total'] / result['grp']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpp'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp'] = parseFloat(result['grp']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_diff'] = parseFloat(result['grp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_goal'] = parseFloat(grp_goal);
                    if (result['grp_goal'] > 0) {
                        result['cpp_goal'] = parseFloat(result['total'] / result['grp_goal']).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        perce = parseFloat((parseFloat(grp) * 100) / parseFloat(grp_goal));
                    } else {
                        result['cpp_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['grp_goal'] = parseFloat(result['grp_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['grp_perc'] = parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';

                    result['gri'] = parseFloat(gri);
                    result['gri_goal'] = parseFloat(gri_goal);
                    result['impressions'] = parseFloat(impressions);
                    result['imp_goal'] = parseFloat(imp_goal);
                    result['imp_diff'] = parseFloat(impressions) - parseFloat(imp_goal);

                    var imp_perce = 0;
                    if(parseFloat(imp_goal) > 0)
                        imp_perce = parseFloat((parseFloat(impressions) * 100) / parseFloat(imp_goal));

                    result['imp_perc'] = parseFloat(imp_perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    })+ '%';
                    result['imp_diff'] = parseFloat(result['imp_diff']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    var div  = (report.type == 'msa') ? 10 : 1;
                    if (result['gri'] > 0) {
                        result['cpm'] = parseFloat(result['total'] / (result['gri']/div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    } else {
                        result['cpm'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }

                    if (result['gri_goal'] > 0) {
                        result['cpm_goal'] = parseFloat(result['total'] / (result['gri_goal']/div)).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                        perce = parseFloat((parseFloat(gri) * 100) / parseFloat(gri_goal));
                    } else {
                        result['cpm_goal'] = parseFloat(0).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        });
                    }
                    result['impressions'] = parseFloat(result['impressions']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });
                    result['imp_goal'] = parseFloat(result['imp_goal']).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    });

                    result['total'] = parseFloat(result['total']).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    if (type === 'weeks')
                        console.log('level 3 results ', result);
                }
                if (type === 'weeks') {
                    console.log('result AGG - ' + type + ': ', result);
                }

                return result;
            } else
                return false;
        };
        gridCampBreakoutSta.rowData = [];
        gridCampBreakoutWeek.rowData = [];
        gridCampBreakoutDP.rowData = [];
        gridCampBreakoutDPCode.rowData = [];
        var rowData = [];
        var station_totals = [];
        var week_totals = [];
        var dayparts_totals = [];
        var overall = [];
        overall = {
            ads: 0,
            total:0,
            total_delivered: 0,
            grp: 0,
            grp_goal: 0,
            rating_total:0,
            impressions: 0,
            imp_goal: 0,

        };
        for(var demo_id in secondary_demos){
            overall['imp_goal_'+ demo_id] = 0;
            overall['grp_goal_'+ demo_id] = 0;
            overall['rating_total_'+ demo_id] = 0;
            overall['impressions_'+ demo_id] = 0;
            overall['grp_'+ demo_id] = 0;
            overall['rating_total_'+ demo_id] = 0;
        }
        var dyapart_code_totals = [];
        var array_st = [];
        var array_week = [];
        var array_dp = [];
        var array_dp_code = [];
        console.log('grid_rows_grid_rows_ ', grid_rows)

        for (var i in grid_rows) {
            if(typeof station_totals[grid_rows[i].vendor_name] === 'undefined') {
                array_st.push(grid_rows[i].vendor_name);
                station_totals[grid_rows[i].vendor_name] = [];
                station_totals[grid_rows[i].vendor_name]  = {
                    ads: 0,
                    total:0,
                    total_delivered: 0,
                    grp: 0,
                    grp_goal: 0,
                    rating_total:0,
                    impressions: 0,
                    imp_goal: 0,

                };
                for(var demo_id in secondary_demos){
                    station_totals[grid_rows[i].vendor_name]['imp_goal_'+ demo_id] = 0;
                    station_totals[grid_rows[i].vendor_name]['grp_goal_'+ demo_id] = 0;
                    station_totals[grid_rows[i].vendor_name]['impressions_'+ demo_id] = 0;
                    station_totals[grid_rows[i].vendor_name]['rating_total_'+ demo_id] = 0;
                    station_totals[grid_rows[i].vendor_name]['grp_'+ demo_id] = 0;
                }
            }
            if(typeof week_totals[grid_rows[i].week_string] === 'undefined') {
                array_week.push(grid_rows[i].week_string);
                week_totals[grid_rows[i].week_string] = [];
                week_totals[grid_rows[i].week_string]  = {
                    ads: 0,
                    total:0,
                    total_delivered: 0,
                    grp: 0,
                    grp_goal: 0,
                    rating_total: 0,
                    impressions: 0,
                    imp_goal: 0,

                };
                for(var demo_id in secondary_demos){
                    week_totals[grid_rows[i].week_string]['imp_goal_'+ demo_id] = 0;
                    week_totals[grid_rows[i].week_string]['grp_goal_'+ demo_id] = 0;
                    week_totals[grid_rows[i].week_string]['impressions_'+ demo_id] = 0;
                    week_totals[grid_rows[i].week_string]['rating_total_'+ demo_id] = 0;
                    week_totals[grid_rows[i].week_string]['grp_'+ demo_id] = 0;
                }
            }
            if(typeof dayparts_totals[grid_rows[i].line_days+'  '+ grid_rows[i].line_time] === 'undefined') {
                array_dp.push(grid_rows[i].line_days+'  '+grid_rows[i].line_time);
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time] = [];
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]  = {
                    ads: 0,
                    total:0,
                    total_delivered: 0,
                    grp: 0,
                    grp_goal: 0,
                    impressions: 0,
                    imp_goal: 0,
                };
                for(var demo_id in secondary_demos){
                    dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['imp_goal_'+ demo_id] = 0;
                    dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp_goal_'+ demo_id] = 0;
                    dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['impressions_'+ demo_id] = 0;
                    dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['rating_total_'+ demo_id] = 0;
                    dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp_'+ demo_id] = 0;
                }
            }
            if(typeof dyapart_code_totals[grid_rows[i].daypart] === 'undefined') {
                array_dp_code.push(grid_rows[i].daypart);
                dyapart_code_totals[grid_rows[i].daypart] = [];
                dyapart_code_totals[grid_rows[i].daypart]  = {
                    ads: 0,
                    total:0,
                    total_delivered: 0,
                    grp: 0,
                    grp_goal: 0,
                    impressions: 0,
                    imp_goal: 0,
                };
                for(var demo_id in secondary_demos){
                    dyapart_code_totals[grid_rows[i].daypart]['imp_goal_'+ demo_id] = 0;
                    dyapart_code_totals[grid_rows[i].daypart]['grp_goal_'+ demo_id] = 0;
                    dyapart_code_totals[grid_rows[i].daypart]['impressions_'+ demo_id] = 0;
                    dyapart_code_totals[grid_rows[i].daypart]['rating_total_'+ demo_id] = 0;
                    dyapart_code_totals[grid_rows[i].daypart]['grp_'+ demo_id] = 0;
                }
            }
            var  grp = parseFloat(grid_rows[i].real_rating).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
            var  grp_goal = parseFloat(grid_rows[i].old_rating).toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });

            station_totals[grid_rows[i].vendor_name]['ads']  += (typeof grid_rows[i].no_invoice_added !== 'undefined') ? 0: 1;
            station_totals[grid_rows[i].vendor_name]['total']  += !isNaN(parseFloat(grid_rows[i].rate)) ? parseFloat(grid_rows[i].rate) : 0;
            station_totals[grid_rows[i].vendor_name]['grp']  += !isNaN( parseFloat(grp.replace(/,/g, '')) ) ? parseFloat(grp.replace(/,/g, '')) : 0;
            station_totals[grid_rows[i].vendor_name]['grp_goal']  +=!isNaN( parseFloat(grp_goal.replace(/,/g, '')) ) ? parseFloat(grp_goal.replace(/,/g, '')) : 0;
            station_totals[grid_rows[i].vendor_name]['rating_total'] += (!isNaN(parseFloat(grid_rows[i].real_rating.toFixed(1))) ? parseFloat(grid_rows[i].real_rating.toFixed(1)) : 0);
            station_totals[grid_rows[i].vendor_name]['impressions']  += !isNaN( parseFloat(grid_rows[i].real_impressions) ) ? parseFloat(grid_rows[i].real_impressions) : 0;
            station_totals[grid_rows[i].vendor_name]['imp_goal']  += !isNaN( parseFloat(grid_rows[i].old_impressions) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1'))) : 0;

            week_totals[grid_rows[i].week_string]['ads']  += (typeof grid_rows[i].no_invoice_added !== 'undefined') ? 0: 1;
            week_totals[grid_rows[i].week_string]['total']  += !isNaN(parseFloat(grid_rows[i].rate)) ? parseFloat(grid_rows[i].rate) : 0;
            week_totals[grid_rows[i].week_string]['grp']  += !isNaN( parseFloat(grp.replace(/,/g, '')) ) ? parseFloat(grp.replace(/,/g, '')) : 0;
            week_totals[grid_rows[i].week_string]['grp_goal']  += !isNaN( parseFloat(grp_goal.replace(/,/g, '')) ) ? parseFloat(grp_goal.replace(/,/g, '')) : 0;
            week_totals[grid_rows[i].week_string]['rating_total'] += (!isNaN(parseFloat(grid_rows[i].real_rating.toFixed(1))) ? parseFloat(grid_rows[i].real_rating.toFixed(1)) : 0);
            week_totals[grid_rows[i].week_string]['impressions']  += !isNaN( parseFloat(grid_rows[i].real_impressions) ) ? parseFloat(grid_rows[i].real_impressions) : 0;
            week_totals[grid_rows[i].week_string]['imp_goal']  += !isNaN( parseFloat(grid_rows[i].old_impressions) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1'))) : 0;

            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['ads']  ++;
            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['total']  += !isNaN(parseFloat(grid_rows[i].rate)) ? parseFloat(grid_rows[i].rate) : 0;
            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp']  += !isNaN( parseFloat(grp.replace(/,/g, '')) ) ? parseFloat(grp.replace(/,/g, '')) : 0;
            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp_goal']  += !isNaN( parseFloat(grp_goal.replace(/,/g, '')) ) ? parseFloat(grp_goal.replace(/,/g, '')) : 0;
            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['impressions']  += !isNaN( parseFloat(grid_rows[i].real_impressions) ) ? parseFloat(grid_rows[i].real_impressions) : 0;
            dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['imp_goal']  += !isNaN( parseFloat(grid_rows[i].old_impressions) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1'))) : 0;

            overall['ads']  += (typeof grid_rows[i].no_invoice_added !== 'undefined') ? 0: 1;
            overall['total']  += !isNaN(parseFloat(grid_rows[i].rate)) ? parseFloat(grid_rows[i].rate) : 0;
            overall['grp']  += !isNaN( parseFloat(grp.replace(/,/g, '')) ) ? parseFloat(grp.replace(/,/g, '')) : 0;
            overall['grp_goal']  +=!isNaN( parseFloat(grp_goal.replace(/,/g, '')) ) ? parseFloat(grp_goal.replace(/,/g, '')) : 0;
            overall['rating_total'] += (!isNaN(parseFloat(grid_rows[i].real_rating.toFixed(1))) ? parseFloat(grid_rows[i].real_rating.toFixed(1)) : 0);
            overall['impressions']  += !isNaN( parseFloat(grid_rows[i].real_impressions) ) ? parseFloat(grid_rows[i].real_impressions) : 0;
            overall['imp_goal']  += !isNaN( parseFloat(grid_rows[i].old_impressions) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1'))) : 0;

            dyapart_code_totals[grid_rows[i].daypart]['ads']  += (typeof grid_rows[i].no_invoice_added !== 'undefined') ? 0: 1;
            dyapart_code_totals[grid_rows[i].daypart]['total']  += !isNaN(parseFloat(grid_rows[i].rate)) ? parseFloat(grid_rows[i].rate) : 0;
            dyapart_code_totals[grid_rows[i].daypart]['grp']  += !isNaN( parseFloat(grp.replace(/,/g, '')) ) ? parseFloat(grp.replace(/,/g, '')) : 0;
            dyapart_code_totals[grid_rows[i].daypart]['grp_goal']  +=!isNaN( parseFloat(grp_goal.replace(/,/g, '')) ) ? parseFloat(grp_goal.replace(/,/g, '')) : 0;
            dyapart_code_totals[grid_rows[i].daypart]['rating_total'] += (!isNaN(parseFloat(grid_rows[i].real_rating.toFixed(1))) ? parseFloat(grid_rows[i].real_rating.toFixed(1)) : 0);
            dyapart_code_totals[grid_rows[i].daypart]['impressions']  += !isNaN( parseFloat(grid_rows[i].real_impressions) ) ? parseFloat(grid_rows[i].real_impressions) : 0;
            dyapart_code_totals[grid_rows[i].daypart]['imp_goal']  += !isNaN( parseFloat(grid_rows[i].old_impressions) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1'))) : 0;

            var perce = 0;
            var grp_dif = 0;
            if (!isNaN(parseFloat(grid_rows[i].real_rating)) && !isNaN(parseFloat(grid_rows[i].old_rating)) && parseFloat(grid_rows[i].old_rating) > 0) {
                var real = Number(Math.round(grid_rows[i].real_rating + 'e1') + 'e-1');
                var old = Number(Math.round(grid_rows[i].old_rating + 'e1') + 'e-1');
                perce = parseFloat((parseFloat(real) * 100) / parseFloat(old));
            }
            if (!isNaN(parseFloat(grid_rows[i].real_rating)) && !isNaN(parseFloat(grid_rows[i].old_rating))) {
                var real = Number(Math.round(grid_rows[i].real_rating + 'e1') + 'e-1');
                var old = Number(Math.round(grid_rows[i].old_rating + 'e1') + 'e-1');
                grp_dif = parseFloat(real) - parseFloat(old);
            }

            var imp_perce = 0;
            var imp_dif = 0;
            if (!isNaN(parseFloat(grid_rows[i].real_impressions)) && !isNaN(parseFloat(grid_rows[i].old_impressions)) && parseFloat(grid_rows[i].old_impressions) > 0) {
                var real = Number(Math.round(grid_rows[i].real_impressions + 'e1') + 'e-1');
                var old = Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1');
                imp_perce = parseFloat((parseFloat(real) * 100) / parseFloat(old));
            }
            if (!isNaN(parseFloat(grid_rows[i].real_impressions)) && !isNaN(parseFloat(grid_rows[i].old_impressions))) {
                var real = Number(Math.round(grid_rows[i].real_impressions + 'e1') + 'e-1');
                var old = Number(Math.round(grid_rows[i].old_impressions + 'e1') + 'e-1');
                imp_dif = parseFloat(real) - parseFloat(old);
            }
            var row = {
                daypart: grid_rows[i].line_days+'  '+grid_rows[i].line_time,
                daypart_code: grid_rows[i].daypart,
                station: grid_rows[i].vendor_name,
                week: moment(grid_rows[i].week_string),
                day:  grid_rows[i].day_of_week +' ' +moment(grid_rows[i].day).format('MM/DD/YYYY'),
                time: grid_rows[i].run_time,
                line_days: grid_rows[i].line_days,
                line_time: grid_rows[i].line_time,
                program: grid_rows[i].program,
                vendor_id: grid_rows[i].vendor_id,
                len: ':'+ grid_rows[i].length,
                ads: (typeof grid_rows[i].no_invoice_added !== 'undefined') ? 0: 1,
                grp: parseFloat(grid_rows[i].real_rating).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                impressions: parseFloat(grid_rows[i].real_impressions).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                imp_goal: parseFloat(grid_rows[i].old_impressions).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                cpm: parseFloat(grid_rows[i].real_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),
                cpm_goal: parseFloat(grid_rows[i].old_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),

                cpp: parseFloat(grid_rows[i].real_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),
                grp_goal:  parseFloat(grid_rows[i].old_rating).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                cpp_goal:parseFloat(grid_rows[i].old_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),
                total:parseFloat(grid_rows[i].rate).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }),
                grp_diff: parseFloat(grp_dif).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                grp_perc: parseFloat(perce).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                })+ '%',

                imp_diff: parseFloat(imp_dif).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }),
                imp_perc: parseFloat(imp_perce).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                })+ '%',
            }

            //Secondary demos
            var demo_array_values = [];
            for(var demo_id in secondary_demos){
                grid_rows[i]['real_rating_'+ demo_id] = typeof grid_rows[i]['real_rating_'+ demo_id] !== 'undefined' ? grid_rows[i]['real_rating_'+ demo_id] : 0;
                grid_rows[i]['old_rating_'+ demo_id] = typeof grid_rows[i]['old_rating_'+ demo_id] !== 'undefined' ? grid_rows[i]['old_rating_'+ demo_id] : 0;
                var d = typeof grid_rows[i]['real_rating_'+ demo_id] !== 'undefined' ? grid_rows[i]['real_rating_'+ demo_id] : 0;
                demo_array_values['grp_'+ demo_id] = parseFloat(grid_rows[i]['real_rating_'+ demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                demo_array_values['grp_goal_'+ demo_id] = parseFloat(grid_rows[i]['old_rating_'+ demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });

                station_totals[grid_rows[i].vendor_name]['grp_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) : 0;
                station_totals[grid_rows[i].vendor_name]['grp_goal_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) : 0;
                station_totals[grid_rows[i].vendor_name]['impressions_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_impressions_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_impressions_' + demo_id]) : 0;
                station_totals[grid_rows[i].vendor_name]['rating_total_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_rating_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_rating_' + demo_id]) : 0;
                station_totals[grid_rows[i].vendor_name]['imp_goal_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1'))) : 0;

                week_totals[grid_rows[i].week_string]['grp_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) : 0;
                week_totals[grid_rows[i].week_string]['grp_goal_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) : 0;
                week_totals[grid_rows[i].week_string]['impressions_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_impressions_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_impressions_' + demo_id]) : 0;
                week_totals[grid_rows[i].week_string]['rating_total_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_rating_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_rating_' + demo_id]) : 0;
                week_totals[grid_rows[i].week_string]['imp_goal_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1'))) : 0;

                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) : 0;
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['grp_goal_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) : 0;
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['impressions'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_impressions_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_impressions_' + demo_id]) : 0;
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['rating_total'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_rating_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_rating_' + demo_id]) : 0;
                dayparts_totals[grid_rows[i].line_days + '  ' + grid_rows[i].line_time]['imp_goal_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1'))) : 0;

                overall['grp_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) : 0;
                overall['grp_goal_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) : 0;
                overall['impressions_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_impressions_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_impressions_' + demo_id]) : 0;
                overall['rating_total_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_rating_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_rating_' + demo_id]) : 0;
                overall['imp_goal_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1'))) : 0;

                dyapart_code_totals[grid_rows[i].daypart]['grp_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_'+ demo_id].replace(/,/g, '')) : 0;
                dyapart_code_totals[grid_rows[i].daypart]['grp_goal_'+ demo_id]  += !isNaN( parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) ) ? parseFloat(demo_array_values['grp_goal_'+ demo_id].replace(/,/g, '')) : 0;
                dyapart_code_totals[grid_rows[i].daypart]['impressions_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_impressions_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_impressions_' + demo_id]) : 0;
                dyapart_code_totals[grid_rows[i].daypart]['rating_total_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['real_rating_' + demo_id]) ) ? parseFloat(grid_rows[i]['real_rating_' + demo_id]) : 0;
                dyapart_code_totals[grid_rows[i].daypart]['imp_goal_'+ demo_id]  += !isNaN( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) ) ? parseFloat(parseFloat(Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1'))) : 0;

                demo_array_values['perce_' + demo_id] = 0;
                demo_array_values['imp_perce_' + demo_id] = 0;
                demo_array_values['imp_diff_' + demo_id] = 0;
                demo_array_values['grp_diff_' + demo_id] = 0;

                if (!isNaN(parseFloat(grid_rows[i]['real_rating_'+ demo_id])) && !isNaN(parseFloat(grid_rows[i]['old_rating_'+ demo_id]))) {
                    var real = Number(Math.round(grid_rows[i]['real_rating_'+ demo_id] + 'e1') + 'e-1');
                    var old = Number(Math.round(grid_rows[i]['old_rating_'+ demo_id] + 'e1') + 'e-1');
                    demo_array_values['grp_diff_' + demo_id] = parseFloat(real) - parseFloat(old);

                    if(parseFloat(grid_rows[i]['old_rating_'+ demo_id]) > 0)
                        demo_array_values['perce_' + demo_id]  = parseFloat((parseFloat(real) * 100) / parseFloat(old));
                }

                if (!isNaN(parseFloat(grid_rows[i]['real_impressions_'+ demo_id])) && !isNaN(parseFloat(grid_rows[i]['old_impressions_'+ demo_id]))) {
                    var real = Number(Math.round(grid_rows[i]['real_impressions_'+ demo_id] + 'e1') + 'e-1');
                    var old = Number(Math.round(grid_rows[i]['old_impressions_'+ demo_id] + 'e1') + 'e-1');
                    demo_array_values['imp_diff_' + demo_id] = parseFloat(real) - parseFloat(old);

                    if( parseFloat(grid_rows[i]['old_impressions_'+ demo_id]) > 0)
                        demo_array_values['imp_perce_' + demo_id] = parseFloat((parseFloat(real) * 100) / parseFloat(old));
                }
                row['impressions_' + demo_id] = parseFloat(grid_rows[i]['real_impressions_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['imp_goal_' + demo_id] =parseFloat(grid_rows[i]['old_impressions_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['cpm_' + demo_id] = parseFloat(grid_rows[i]['real_cpm_' + demo_id]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpm_goal_' + demo_id] = parseFloat(grid_rows[i]['old_cpm_' + demo_id]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpp_' + demo_id] = parseFloat(grid_rows[i]['real_cpp_' + demo_id]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['cpp_goal_' + demo_id] = parseFloat(grid_rows[i]['old_cpp_' + demo_id]).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                });
                row['grp_goal_' + demo_id] = parseFloat(grid_rows[i]['old_rating_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                row['grp_' + demo_id] = parseFloat(grid_rows[i]['real_rating_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });
                  row['grp_diff_' + demo_id] = parseFloat(demo_array_values['grp_diff_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });

                row['grp_perc_' + demo_id] = parseFloat(demo_array_values['perce_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                })+ '%';

                row['imp_diff_' + demo_id] = parseFloat(demo_array_values['imp_diff_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                });

                row['imp_perce_' + demo_id] = parseFloat(demo_array_values['imp_perce_' + demo_id]).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                })+ '%';

            }
            rowData.push(row);
        }
        console.log('rowData_rowData_rowData', rowData)
        fill_summary_totals(station_totals, week_totals, dayparts_totals, overall, dyapart_code_totals, array_st, array_week, array_dp, array_dp_code);
        fill_report_details(overall, station_totals);

        var to_sort = JSON.parse(JSON.stringify(rowData));
        var to_sort_m = JSON.parse(JSON.stringify(rowData));
        var to_sort_y = JSON.parse(JSON.stringify(rowData));
        var to_sort_z = JSON.parse(JSON.stringify(rowData));

        var orderBy = ['station', 'week'];
        var sorted = multisort(to_sort, orderBy)
        gridCampBreakoutSta.rowData = sorted;

        var orderBy = ['week', 'station'];
        var sorted_two = multisort(to_sort_m, orderBy)
        gridCampBreakoutWeek.rowData = sorted_two;

        var orderBy = [ 'daypart', 'station'];
        var sorted_three = multisort(to_sort_y, orderBy)
        gridCampBreakoutDP.rowData = sorted_three;

        var orderBy = [ 'daypart_code', 'station'];
        var sorted_four = multisort(to_sort_z, orderBy)
        gridCampBreakoutDPCode.rowData = sorted_four;

        $('#myGridBreakoutSta').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakoutSta');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCampBreakoutSta);

        $('#myGridBreakoutWeek').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakoutWeek');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCampBreakoutWeek);

        $('#myGridBreakoutDP').html('');
        var gridCampBreakoutX = document.querySelector('#myGridBreakoutDP');
        var grid = new agGrid.Grid(gridCampBreakoutX, gridCampBreakoutDP);


        $('#myGridBreakoutDPCode').html('');
        var gridCampBreakoutDPCodeX = document.querySelector('#myGridBreakoutDPCode');
        var grid = new agGrid.Grid(gridCampBreakoutDPCodeX, gridCampBreakoutDPCode);

        function fill_summary_totals(station_totals, week_totals, dayparts_totals, overall, dyapart_code_totals, array_st, array_week, array_dp, array_dp_code) {
            var tr_colspan = 5;
            var html = '';
            html += '<div class="table-wrapper" style="margin-top: 1%; "><table id="sta_overall_sum_totals" class="table table-bordered table-striped table-condensed" style="">';
            html += '<thead>';
            var html_group = '';
        //    if(typeof secondary_demos.length === 'undefined'){
                html_group += '<tr>';
                html_group += '<th colspan="5" style=""></th>';
                var colspan = 0;
                if(metrics.indexOf('grp') !== -1)
                    colspan += 6;
                if(metrics.indexOf('impressions') !== -1)
                    colspan += 6;

                html_group += '<th colspan="'+ colspan+'" style="background-color: #99CCCC; color: black !important;font-weight: 800; padding: 2px !important;">'+ main_demo +' (Main Demo)</th>';
                var i = 2;
                for(var ind in secondary_demos){
                    var color = i === 2 ? '#b4c5d3' : '#99CCCC';
                    var text = secondary_demos[ind][0].demo_source !== 'comscore' ? secondary_demos[ind][0].demo_type.toUpperCase() + '-' + secondary_demos[ind][0].demo_name : secondary_demos[ind][0].demo_name;
                    html_group += '<th colspan="'+ colspan+'" style="background-color: '+ color +'; color: black !important;font-weight: 800;padding: 2px !important;">'+ text +'</th>';
                    i = i === 2 ? 1 : 2;
                }
                html_group += '</tr>';
                tr_colspan += parseInt(colspan);
         //   }

            html += html_group;
            var padding_overall = '';
            var padding_station = '';
            var padding_week = '';
            var padding_daypart = '';
            var padding_buy_line = '';
          //  if(typeof secondary_demos.length === 'undefined'){
                var large = 0;
                var station_large = 0;
                for (var ind in array_st) {
                    if(large < array_st[ind].length) {
                        large = array_st[ind].length;
                        station_large = parseInt(array_st[ind].length);
                    }
                }
                var buy_line_large = 0;
               for (var ind in array_dp){
                   if(large < array_dp[ind].length) {
                       large = array_dp[ind].length;
                       buy_line_large = parseInt(array_dp[ind].length);
                   }
               }

                var px = large * 7;
                var padding_ov = parseInt(px) + parseInt(20);

                var pad_ov =  parseInt(padding_ov) - (49);
                padding_overall = 'padding-right: '+ pad_ov +'px !important;';
                padding_station = 'padding-right: '+ pad_ov +'px !important;';
                padding_daypart = 'padding-right: '+ pad_ov +'px !important;';

                var pad_week = parseInt(padding_ov) - parseInt(30);
                padding_week = 'padding-right: '+ pad_week +'px !important;';

                var pad_buy_line = parseInt(padding_ov) - parseInt(46);
                padding_buy_line = 'padding-right: '+ pad_buy_line +'px !important;';

          //  }

            //heather
            html += '<tr>' +
                '<th style="'+ padding_overall +'">Overall</th>' +
                '<th> Ads '+ report_type +'</th>' +
                '<th> Gross Cost '+ report_type +'</th>' +
                '<th> Ads Approved</th>' +
                '<th> Gross Cost Approved</th>' ;

            //Main Demo heather
            if(metrics.indexOf('grp') !== -1)
                html+= '<th> GRP '+ report_type +'</th> <th> CPP '+ report_type +'</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' '+ report_type +'</th> <th> CPM '+ report_type +'</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html += '<th> GRP Delivered</th><th> CPP Delivered</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' Delivered</th> <th> CPM Delivered</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html+=  '<th> GRP Diff.</th><th> GRP Delivered %</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=  '<th> '+ imp_type +' Diff.</th><th> '+ imp_type +' Delivered %</th>' ;

            //Seoncary demos heather
            for(var ind in secondary_demos) {
                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP ' + report_type + '</th> <th> CPP ' + report_type + '</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' ' + report_type + '</th> <th> CPM ' + report_type + '</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Delivered</th><th> CPP Delivered</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Delivered</th> <th> CPM Delivered</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Diff.</th><th> GRP Delivered %</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Diff.</th><th> ' + imp_type + ' Delivered %</th>';
            }

            html+=   '</tr></thead>';
            html += '<tbody>';

            var perce = 0;
            var grp_dif = 0;

            var perce_imp = 0;
            var div  = (report.type == 'msa') ? 10 : 1;

            var ord_gross = 0;
            var ord_ads = 0;
            var ord_gri = 0;
            var ord_grp = 0;
            var sec_array = [];
            for(var ind in secondary_demos) {
                sec_array['ord_gri_'+ ind] = 0;
                sec_array['ord_grp_'+ ind] = 0;
            }
            for(var xd in array_st){
                var i = array_st[xd];
                ord_gross += parseFloat(stations_values[i]['total'][1]);
                ord_ads += parseInt(stations_values[i]['total'][0]);
                ord_gri += parseFloat(stations_values[i]['total'][3]);
                ord_grp += parseFloat(stations_values[i]['total'][2]);

                for(var ind in secondary_demos){
                    sec_array['ord_gri_'+ ind] += parseFloat(stations_values[i]['total']['sec_demos'][ind]['imp']);
                    sec_array['ord_grp_'+ ind] += parseFloat(stations_values[i]['total']['sec_demos'][ind]['rat']);
                }
            }

            if (parseFloat(ord_grp) > 0)
                perce = parseFloat((parseFloat(overall.grp) * 100) / parseFloat(ord_grp));
            grp_dif = parseFloat(ord_grp) -  parseFloat(overall.grp);

            if (parseFloat(ord_gri) > 0)
                perce_imp = parseFloat((parseFloat(overall.impressions) * 100) / parseFloat(ord_gri));
            imp_dif = parseFloat(ord_gri) - parseFloat(overall.impressions);

            var grp_sym = '';
            var imp_sym = '';
            if(grp_dif !== 0)
                grp_sym = (grp_dif > 0) ? '-' : '+';
            if(imp_dif !== 0)
                imp_sym = (imp_dif > 0) ? '-' : '+';

            var del_overal = overall.total;
            var cpp = (overall.grp > 0) ? del_overal / overall.grp : 0;
            var cpm = (overall.impressions > 0) ? del_overal / (overall.impressions /div) : 0;

            var ord_cpp = (ord_grp > 0) ? ord_gross / ord_grp : 0;
            var ord_cpm = (ord_gri/ div > 0) ? ord_gross / (ord_gri/div) : 0;

            html += '<tr>' +
                '<td></td>' ;

            //shared info part
            html += '<td>'+ ord_ads+'</td>';
            html += '<td>' + parseFloat(ord_gross).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            }), +'</td>';
            html +=  '<td>' + overall.ads + '</td>' ;
            html +=  '<td>' + parseFloat(overall.total).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';

            //Main demo part
            if(metrics.indexOf('grp') !== -1) {
                html += '<td>' + parseFloat(ord_grp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
                html += '<td>' + parseFloat(ord_cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
            }
            if(metrics.indexOf('impressions') !== -1) {
                html += '<td>' + parseFloat(ord_gri).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
                html += '<td>' + parseFloat(ord_cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
            }
            if(metrics.indexOf('grp') !== -1){
                html += '<td>' + parseFloat(overall.grp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';

                html += '<td>' + parseFloat(cpp).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
            }
            if(metrics.indexOf('impressions') !== -1) {
                html += '<td>' + parseFloat(overall.impressions).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
                html += '<td>' + parseFloat(cpm).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
            }
            if(metrics.indexOf('grp') !== -1) {
                html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
                html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
            }
            if(metrics.indexOf('impressions') !== -1) {
                html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
                html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                }), +'</td>';
            }

            //secondary demos part
            for(var ind in secondary_demos){
                //Diff && Percents calculations
                perce = parseFloat(sec_array['ord_grp_'+ ind]) > 0 ? (parseFloat(overall['grp_' + ind]) * 100) /  parseFloat(sec_array['ord_grp_'+ ind]) : 0;
                perce_imp = parseFloat(sec_array['ord_gri_'+ ind]) > 0 ? (parseFloat(overall['impressions_' + ind]) * 100) /  parseFloat(sec_array['ord_gri_'+ ind]) : 0;
                imp_dif = parseFloat(sec_array['ord_gri_'+ ind]) - parseFloat(parseFloat(overall['impressions_'+ ind]));
                grp_dif = parseFloat(sec_array['ord_grp_'+ ind]) -  parseFloat(overall['grp_'+ ind])
                grp_sym =  grp_dif > 0 ? '-' : '+';
                grp_sym =  grp_dif === 0 ? '' : grp_sym;
                imp_sym = imp_dif > 0 ? '-' : '+';
                imp_sym = imp_dif === 0 ? '' : imp_sym;

                //ordered
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(sec_array['ord_grp_'+ ind]).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    var sec_cpp =  (sec_array['ord_grp_'+ ind] > 0) ? ord_gross / sec_array['ord_grp_'+ ind] : 0;
                    html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(sec_array['ord_gri_'+ ind]).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    var sec_cpp = (sec_array['ord_gri_'+ ind]/ div > 0) ? ord_gross / (sec_array['ord_gri_'+ ind]/div) : 0;
                    html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }

                //delivered
                if(metrics.indexOf('grp') !== -1){
                    html += '<td>' + parseFloat(overall['grp_' + ind]).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    var sec_cpp =  (overall['grp_' + ind] > 0) ? ord_gross / overall['grp_' + ind] : 0;
                    html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(overall['impressions_' + ind]).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    var sec_cpp = (overall['impressions_'+ ind]/ div > 0) ? ord_gross / (overall['impressions_'+ ind]/div) : 0;
                    html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }

                //Diff && Percents HTML
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
            }

            html += '</tr>';
            html += '</tbody>' ;

            //Stations
           html += '</table></div><div class="table-wrapper" style="margin-top: 1%;"><table id="sta_sum_totals" class="table table-bordered table-striped table-condensed" >';
           // html += '<tr style="background-color: #f6f6f6; height: 20px"> </tr>';
            html += '<thead>';
            html += html_group;
            html += '<tr>' +
                '<th style="'+ padding_station +'">Station</th>' +
                '<th> Ads '+ report_type +'</th>' +
                '<th> Gross Cost '+ report_type +'</th>' +
                '<th> Ads Approved</th>' +
                '<th> Gross Cost Approved</th>' ;

            //Main demo heather
            if(metrics.indexOf('grp') !== -1)
                html+= '<th> GRP '+ report_type +'</th> <th> CPP '+ report_type +'</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + '  '+ report_type +'</th> <th> CPM '+ report_type +'</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html += '<th> GRP Delivered</th><th> CPP Delivered</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' Delivered</th> <th> CPM Delivered</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html+=  '<th> GRP Diff.</th><th> GRP Delivered %</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=  '<th> '+ imp_type +' Diff.</th><th> '+ imp_type +' Delivered %</th>' ;

            //Secondary demos headther
            for(var ind in secondary_demos) {
                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP ' + report_type + '</th> <th> CPP ' + report_type + '</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' ' + report_type + '</th> <th> CPM ' + report_type + '</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Delivered</th><th> CPP Delivered</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Delivered</th> <th> CPM Delivered</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Diff.</th><th> GRP Delivered %</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Diff.</th><th> ' + imp_type + ' Delivered %</th>';
            }
            html+=   '</tr></thead>';
            html += '<tbody>';
            array_st.sort();
            for(var ind in secondary_demos) {
                sec_array['ord_gri_'+ ind] = 0;
                sec_array['ord_grp_'+ ind] = 0;
            }
            for (var ind in array_st) {
                var camp  = array_st[ind];
                var cpp = (station_totals[camp].grp > 0) ? station_totals[camp].total / station_totals[camp].grp : 0;
                var cpp_goal = (station_totals[camp].grp_goal > 0) ? station_totals[camp].total / station_totals[camp].grp_goal : 0;

                var perce = 0;
                var grp_dif = 0;

                var perce_imp = 0
                var div  = (report.type == 'msa') ? 10 : 1;
                var cpm = (station_totals[camp].impressions > 0) ? station_totals[camp].total / (station_totals[camp].impressions / div) : 0;
                var cpm_goal = (station_totals[camp].imp_goal > 0) ? station_totals[camp].total / (station_totals[camp].imp_goal / div) : 0;

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;

                var ord_gross = (typeof stations_values[camp] !== 'undefined' && typeof stations_values[camp]['total'] !== 'undefined') ? stations_values[camp]['total'][1] : 0;
                var ord_ads = (typeof stations_values[camp] !== 'undefined' && typeof stations_values[camp]['total'] !== 'undefined') ? stations_values[camp]['total'][0] : 0;
                var ord_grp = (typeof stations_values[camp] !== 'undefined' && typeof stations_values[camp]['total'] !== 'undefined') ? stations_values[camp]['total'][2] : 0;
                var ord_gri = (typeof stations_values[camp] !== 'undefined' && typeof stations_values[camp]['total'] !== 'undefined') ? stations_values[camp]['total'][3] : 0;

                for(var ind in secondary_demos){
                    sec_array['ord_gri_'+ ind] += parseFloat(stations_values[camp]['total']['sec_demos'][ind]['imp']);
                    sec_array['ord_grp_'+ ind] += parseFloat(stations_values[camp]['total']['sec_demos'][ind]['rat']);
                }

                if (parseFloat(ord_gri) > 0)
                    perce_imp = parseFloat((parseFloat(station_totals[camp].impressions) * 100) / parseFloat(ord_gri));
                imp_dif = parseFloat(ord_gri) - parseFloat(station_totals[camp].impressions);

                if (parseFloat(ord_grp) > 0)
                    perce = parseFloat((parseFloat(station_totals[camp].grp) * 100) / parseFloat(ord_grp));
                grp_dif = parseFloat(ord_grp) - parseFloat(station_totals[camp].grp);

                var grp_sym = '';
                var imp_sym = '';
                if(grp_dif !== 0)
                    grp_sym = (grp_dif > 0) ? '-' : '+';
                if(imp_dif !== 0)
                    imp_sym = (imp_dif > 0) ? '-' : '+';

                var ord_cpp = (ord_grp > 0) ? ord_gross / ord_grp : 0;
                var ord_cpm = (ord_gri/ div > 0) ? ord_gross / (ord_gri/div) : 0;

                var del_gross = typeof station_totals[camp].total !== 'undefined' && !isNaN(parseFloat(station_totals[camp].total)) ? station_totals[camp].total : 0;
                var cpp = (station_totals[camp].grp > 0) ? del_gross / station_totals[camp].grp : 0;
                var cpm = (station_totals[camp].impressions > 0) ? del_gross / (station_totals[camp].impressions /div) : 0;

                //Shared part
                html += '<td>'+ ord_ads+'</td>';
                html += '<td>' + parseFloat(ord_gross).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
                html += '<td>' + station_totals[camp].ads + '</td>' +
                    '<td>' + parseFloat(station_totals[camp].total).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';

                //Main demo
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(ord_grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(ord_gri).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(station_totals[camp].grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(station_totals[camp].impressions).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td> '+ grp_sym+'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td> '+imp_sym+'' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }

                //secondary demos part
                for(var ind in secondary_demos){
                    //Diff && Percents calculations
                    perce = parseFloat(sec_array['ord_grp_'+ ind]) > 0 ? (parseFloat(station_totals[camp]['grp_' + ind]) * 100) /  parseFloat(sec_array['ord_grp_'+ ind]) : 0;
                    perce_imp = parseFloat(sec_array['ord_gri_'+ ind]) > 0 ? (parseFloat(station_totals[camp]['impressions_' + ind]) * 100) /  parseFloat(sec_array['ord_gri_'+ ind]) : 0;
                    imp_dif = parseFloat(sec_array['ord_gri_'+ ind]) - parseFloat(parseFloat(station_totals[camp]['impressions_'+ ind]));
                    grp_dif = parseFloat(sec_array['ord_grp_'+ ind]) -  parseFloat(station_totals[camp]['grp_'+ ind])
                    grp_sym =  grp_dif > 0 ? '-' : '+';
                    grp_sym =  grp_dif === 0 ? '' : grp_sym;
                    imp_sym = imp_dif > 0 ? '-' : '+';
                    imp_sym = imp_dif === 0 ? '' : imp_sym;

                    //ordered
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (sec_array['ord_grp_'+ ind] > 0) ? ord_gross / sec_array['ord_grp_'+ ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_gri_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (sec_array['ord_gri_'+ ind]/ div > 0) ? ord_gross / (sec_array['ord_gri_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //delivered
                    if(metrics.indexOf('grp') !== -1){
                        html += '<td>' + parseFloat(station_totals[camp]['grp_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (station_totals[camp]['grp_' + ind] > 0) ? ord_gross / station_totals[camp]['grp_' + ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(station_totals[camp]['impressions_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (station_totals[camp]['impressions_'+ ind]/ div > 0) ? ord_gross / (station_totals[camp]['impressions_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //Diff && Percents HTML
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody>'
            //weeks
             html += '</table></div><div class="table-wrapper" style="margin-top: 1%;"><table id="week_sum_totals" class="table table-bordered table-striped table-condensed" >';
           // html += '<tr style="background-color: #f6f6f6; height: 20px"> </tr>';
            html += '<thead>';
            html += html_group;

            html += '<tr>' +
                '<th style="'+ padding_week +'">Week</th>' +
                '<th> Ads '+ report_type +'</th>' +
                '<th> Gross Cost '+ report_type +'</th>' +
                '<th> Ads Approved</th>' +
                '<th> Gross Cost Approved</th>';

            //Main demo heather
            if(metrics.indexOf('grp') !== -1)
                html+= '<th> GRP '+ report_type +'</th> <th> CPP '+ report_type +'</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' '+ report_type +'</th> <th> CPM '+report_type +'</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html += '<th> GRP Delivered</th><th> CPP Delivered</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' Delivered</th> <th> CPM Delivered</th>' ;

            if(metrics.indexOf('grp') !== -1)
                html+=  '<th> GRP Diff.</th><th> GRP Delivered %</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=  '<th> '+ imp_type +' Diff.</th><th> '+ imp_type +' Delivered %</th>' ;

            //Secondary demo heather
            for(var ind in secondary_demos) {
                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP ' + report_type + '</th> <th> CPP ' + report_type + '</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' ' + report_type + '</th> <th> CPM ' + report_type + '</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Delivered</th><th> CPP Delivered</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Delivered</th> <th> CPM Delivered</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Diff.</th><th> GRP Delivered %</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Diff.</th><th> ' + imp_type + ' Delivered %</th>';
            }

            html += '</tr></thead><tbody>';

            for(var week in week_values){
               if(array_week.indexOf(week) === - 1)
                   array_week.push(week);
            }
            array_week.sort();
            for(var ind in secondary_demos) {
                sec_array['ord_gri_'+ ind] = 0;
                sec_array['ord_grp_'+ ind] = 0;
            }
            for (var ind in array_week) {
                var camp = array_week[ind];
                var perce = 0;
                var grp_dif = 0;
                var perce_imp = 0;
                var div  = (report.type == 'msa') ? 10 : 1;

                html += '<tr>' +
                    '<td>' + moment(camp).format("MMM DD, YYYY") + '</td>' ;

                var ord_gross = (typeof week_values[camp] !== 'undefined' && typeof week_values[camp]['total'] !== 'undefined') ? week_values[camp]['total'][1] : 0;
                var ord_ads = (typeof week_values[camp] !== 'undefined' && typeof week_values[camp]['total'] !== 'undefined') ? week_values[camp]['total'][0] : 0;
                var ord_grp = (typeof week_values[camp] !== 'undefined' && typeof week_values[camp]['total'] !== 'undefined') ? week_values[camp]['total'][2] : 0;
                var ord_gri = (typeof week_values[camp] !== 'undefined' && typeof week_values[camp]['total'] !== 'undefined') ? week_values[camp]['total'][3] : 0;
                var ord_cpp = (ord_grp > 0) ? ord_gross / ord_grp : 0;
                var ord_cpm = (ord_gri/ div > 0) ? ord_gross / (ord_gri/div) : 0;
                if(typeof week_totals[camp] !== 'undefined') {
                    var cost = week_totals[camp].total;
                    var cpp = (week_totals[camp].grp > 0) ? ord_gross / week_totals[camp].grp : 0;
                    var cpm = (week_totals[camp].impressions > 0) ? cost / (week_totals[camp].impressions / div) : 0;
                    var ads = week_totals[camp].ads;
                    var grp = week_totals[camp].grp;
                    var impressions = week_totals[camp].impressions;
                }
                else{
                    var cpp = 0;
                    var cpm = 0;
                    var ads = 0
                    var cost = 0;
                    var grp = 0;
                    var impressions = 0;
                }
                if (parseFloat(ord_gri) > 0)
                    perce_imp = parseFloat((parseFloat(impressions) * 100) / parseFloat(ord_gri));
                imp_dif = parseFloat(ord_gri) - parseFloat(impressions);

                if (parseFloat(ord_grp) > 0)
                    perce = parseFloat((parseFloat(grp) * 100) / parseFloat(ord_grp));
                grp_dif = parseFloat(ord_grp) - parseFloat(grp);
                var grp_sym = '';
                var imp_sym = '';
                if(grp_dif !== 0)
                    grp_sym = (grp_dif > 0) ? '-' : '+';
                if(imp_dif !== 0)
                    imp_sym = (imp_dif > 0) ? '-' : '+';

                for(var ind in secondary_demos){
                    sec_array['ord_gri_'+ ind] += typeof week_values[camp] !== 'undefined' ? parseFloat(week_values[camp]['total']['sec_demos'][ind]['imp']) : 0;
                    sec_array['ord_grp_'+ ind] += typeof week_values[camp] !== 'undefined' ? parseFloat(week_values[camp]['total']['sec_demos'][ind]['rat']) : 0;
                }

                html += '<td>'+ ord_ads+'</td>';
                html += '<td>' + parseFloat(ord_gross).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
                html +=   '<td>' + ads + '</td>' +
                    '<td>' + parseFloat(cost).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';

                //Main Demo part
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(ord_grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(ord_gri).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(impressions).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>'+ imp_sym +'' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }

                //secondary demos part
                for(var ind in secondary_demos){

                    //Diff && Percents calculations
                    if(typeof week_totals[camp] === 'undefined') {
                        week_totals[camp] = {};
                        week_totals[camp]['grp_' + ind] = 0;
                        week_totals[camp]['impressions_' + ind] = 0;
                        week_totals[camp]['ord_grp_' + ind] = 0;
                        week_totals[camp]['ord_gri_' + ind] = 0;
                    }
                    perce = parseFloat(sec_array['ord_grp_'+ ind]) > 0 ? (parseFloat(week_totals[camp]['grp_' + ind]) * 100) /  parseFloat(sec_array['ord_grp_'+ ind]) : 0;
                    perce_imp = parseFloat(sec_array['ord_gri_'+ ind]) > 0 ? (parseFloat(week_totals[camp]['impressions_' + ind]) * 100) /  parseFloat(sec_array['ord_gri_'+ ind]) : 0;
                    imp_dif = parseFloat(sec_array['ord_gri_'+ ind]) - parseFloat(parseFloat(week_totals[camp]['impressions_'+ ind]));
                    grp_dif = parseFloat(sec_array['ord_grp_'+ ind]) -  parseFloat(week_totals[camp]['grp_'+ ind])
                    grp_sym =  grp_dif > 0 ? '-' : '+';
                    grp_sym =  grp_dif === 0 ? '' : grp_sym;
                    imp_sym = imp_dif > 0 ? '-' : '+';
                    imp_sym = imp_dif === 0 ? '' : imp_sym;

                    //ordered
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (sec_array['ord_grp_'+ ind] > 0) ? ord_gross / sec_array['ord_grp_'+ ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_gri_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (sec_array['ord_gri_'+ ind]/ div > 0) ? ord_gross / (sec_array['ord_gri_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //delivered
                    if(metrics.indexOf('grp') !== -1){
                        html += '<td>' + parseFloat(week_totals[camp]['grp_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (week_totals[camp]['grp_' + ind] > 0) ? ord_gross / week_totals[camp]['grp_' + ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(week_totals[camp]['impressions_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (week_totals[camp]['impressions_'+ ind]/ div > 0) ? ord_gross / (week_totals[camp]['impressions_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //Diff && Percents HTML
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody>';

            //daypart codes totals
            html += '</table></div><div class="table-wrapper" style="margin-top: 1%;"><table id="dp_code_sum_totals" class="table table-bordered table-striped table-condensed" >';
           // html += '<tr style="background-color: #f6f6f6; height: 20px"> </tr>';
            html += '<thead>';
            html += html_group;
            html += '<tr>' +
                '<th style="'+ padding_daypart +'" >Daypart</th>' +
                '<th> Ads '+report_type +'</th>' +
                '<th> Gross Cost '+ report_type +'</th>' +
                '<th> Ads Approved</th>' +
                '<th> Gross Cost Approved</th>' ;

            //Main demo heather
            if(metrics.indexOf('grp') !== -1)
                html+= '<th> GRP '+ report_type +'</th> <th> CPP '+ report_type +'</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' '+ report_type +'</th> <th> CPM '+ report_type +'</th>' ;
            if(metrics.indexOf('grp') !== -1)
                html += '<th> GRP Delivered</th><th> CPP Delivered</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' Delivered</th> <th> CPM Delivered</th>' ;
            if(metrics.indexOf('grp') !== -1)
                html+=  '<th> GRP Diff.</th><th> GRP Delivered %</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=  '<th> '+ imp_type +' Diff.</th><th> '+ imp_type +' Delivered %</th>' ;

            //Secondary demo heather
            for(var ind in secondary_demos) {
                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP ' + report_type + '</th> <th> CPP ' + report_type + '</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' ' + report_type + '</th> <th> CPM ' + report_type + '</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Delivered</th><th> CPP Delivered</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Delivered</th> <th> CPM Delivered</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Diff.</th><th> GRP Delivered %</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Diff.</th><th> ' + imp_type + ' Delivered %</th>';
            }
            html +=   '</tr></thead>';
            html += '<tbody>';
            array_dp_code.sort();
            for(var ind in secondary_demos) {
                sec_array['ord_gri_'+ ind] = 0;
                sec_array['ord_grp_'+ ind] = 0;
            }
            for (var ind in array_dp_code) {
                var camp = array_dp_code[ind];
                var cpp = (dyapart_code_totals[camp].grp > 0) ? dyapart_code_totals[camp].total / dyapart_code_totals[camp].grp : 0;
                var cpp_goal = (dyapart_code_totals[camp].grp_goal > 0) ? dyapart_code_totals[camp].total / dyapart_code_totals[camp].grp_goal : 0;
                var perce = 0;
                var grp_dif = 0;

                var perce_imp = 0;
                var div  = (report.type == 'msa') ? 10 : 1;
                var cpm = (dyapart_code_totals[camp].impressions > 0) ? dyapart_code_totals[camp].total / (dyapart_code_totals[camp].impressions /div) : 0;
                var cpm_goal = (dyapart_code_totals[camp].imp_goal > 0) ? dyapart_code_totals[camp].total / (dyapart_code_totals[camp].imp_goal /div): 0;
                for(var ind in secondary_demos){
                    sec_array['ord_gri_'+ ind] += parseFloat(dp_code_values[camp]['total']['sec_demos'][ind]['imp']);
                    sec_array['ord_grp_'+ ind] += parseFloat(dp_code_values[camp]['total']['sec_demos'][ind]['rat']);
                }

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;

                var ord_gross = (typeof dp_code_values[camp] !== 'undefined' && typeof dp_code_values[camp]['total'] !== 'undefined') ? dp_code_values[camp]['total'][1] : 0;
                var ord_ads = (typeof dp_code_values[camp] !== 'undefined' && typeof dp_code_values[camp]['total'] !== 'undefined') ? dp_code_values[camp]['total'][0] : 0;
                var ord_grp = (typeof dp_code_values[camp] !== 'undefined' && typeof dp_code_values[camp]['total'] !== 'undefined') ? dp_code_values[camp]['total'][2] : 0;
                var ord_gri = (typeof dp_code_values[camp] !== 'undefined' && typeof dp_code_values[camp]['total'] !== 'undefined') ? dp_code_values[camp]['total'][3] : 0;

                if (parseFloat(ord_gri) > 0)
                    perce_imp = parseFloat((parseFloat(dyapart_code_totals[camp].impressions) * 100) / parseFloat(ord_gri));
                imp_dif = parseFloat(ord_gri) - parseFloat(dyapart_code_totals[camp].impressions);

                if (parseFloat(ord_grp) > 0)
                    perce = parseFloat((parseFloat(dyapart_code_totals[camp].grp) * 100) / parseFloat(ord_grp));
                grp_dif = parseFloat(ord_grp) - parseFloat(dyapart_code_totals[camp].grp);

                var grp_sym = '';
                var imp_sym = '';
                if(grp_dif !== 0)
                    grp_sym = (grp_dif > 0) ? '-' : '+';
                if(imp_dif !== 0)
                    imp_sym = (imp_dif > 0) ? '-' : '+';

                var ord_cpp = (ord_grp > 0) ? ord_gross / ord_grp : 0;
                var ord_cpm = (ord_gri/ div > 0) ? ord_gross / (ord_gri/div) : 0;

                var del_gross = dyapart_code_totals[camp].total;
                var cpp = (dyapart_code_totals[camp].grp > 0) ? del_gross / dyapart_code_totals[camp].grp : 0;
                var cpm = (dyapart_code_totals[camp].impressions > 0) ? del_gross / (dyapart_code_totals[camp].impressions /div) : 0;

                html += '<td>'+ ord_ads+'</td>';
                html += '<td>' + parseFloat(ord_gross).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
                html += '<td>' + dyapart_code_totals[camp].ads + '</td>' +
                    '<td>' + parseFloat(dyapart_code_totals[camp].total).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';

                //main demos part
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(ord_grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(ord_gri).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(ord_cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(dyapart_code_totals[camp].grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(dyapart_code_totals[camp].impressions).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>'+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>'+ imp_sym +'' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }

                //secondary demos part
                for(var ind in secondary_demos){
                    //Diff && Percents calculations
                    perce = parseFloat(sec_array['ord_grp_'+ ind]) > 0 ? (parseFloat(dyapart_code_totals[camp]['grp_' + ind]) * 100) /  parseFloat(sec_array['ord_grp_'+ ind]) : 0;
                    perce_imp = parseFloat(sec_array['ord_gri_'+ ind]) > 0 ? (parseFloat(dyapart_code_totals[camp]['impressions_' + ind]) * 100) /  parseFloat(sec_array['ord_gri_'+ ind]) : 0;
                    imp_dif = parseFloat(sec_array['ord_gri_'+ ind]) - parseFloat(parseFloat(dyapart_code_totals[camp]['impressions_'+ ind]));
                    grp_dif = parseFloat(sec_array['ord_grp_'+ ind]) -  parseFloat(dyapart_code_totals[camp]['grp_'+ ind])
                    grp_sym =  grp_dif > 0 ? '-' : '+';
                    grp_sym =  grp_dif === 0 ? '' : grp_sym;
                    imp_sym = imp_dif > 0 ? '-' : '+';
                    imp_sym = imp_dif === 0 ? '' : imp_sym;

                    //ordered
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (sec_array['ord_grp_'+ ind] > 0) ? ord_gross / sec_array['ord_grp_'+ ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_gri_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (sec_array['ord_gri_'+ ind]/ div > 0) ? ord_gross / (sec_array['ord_gri_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //delivered
                    if(metrics.indexOf('grp') !== -1){
                        html += '<td>' + parseFloat(dyapart_code_totals[camp]['grp_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (dyapart_code_totals[camp]['grp_' + ind] > 0) ? ord_gross / dyapart_code_totals[camp]['grp_' + ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(dyapart_code_totals[camp]['impressions_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (dyapart_code_totals[camp]['impressions_'+ ind]/ div > 0) ? ord_gross / (dyapart_code_totals[camp]['impressions_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //Diff && Percents HTML
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';


            //daypart totals
            html += '<div class="table-wrapper" style="margin-top: 1%;"><table id="dp_sum_totals" class="table table-bordered table-striped table-condensed" >';
            html += '<thead>';
            html += html_group;
            html += '<tr>' +
                '<th style="'+ padding_buy_line +'">Buy Line</th>' +
                '<th> Ads '+ report_type +'</th>' +
                '<th> Gross Cost '+ report_type +'</th>' +
                '<th> Ads Approved</th>' +
                '<th> Gross Cost Approved</th>' ;

            //Main demo heather
            if(metrics.indexOf('grp') !== -1)
                html+= '<th> GRP '+ report_type +'</th> <th> CPP '+ report_type +'</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' '+ report_type +'</th> <th> CPM '+ report_type +'</th>' ;
            if(metrics.indexOf('grp') !== -1)
                html += '<th> GRP Delivered</th><th> CPP Delivered</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=   '<th> ' + imp_type  + ' Delivered</th> <th> CPM Delivered</th>' ;
            if(metrics.indexOf('grp') !== -1)
                html+=  '<th> GRP Diff.</th><th> GRP Delivered %</th>' ;
            if(metrics.indexOf('impressions') !== -1)
                html+=  '<th> '+ imp_type +' Diff.</th><th> '+ imp_type +' Delivered %</th>' ;

            //Secondary demo heather
            for(var ind in secondary_demos) {
                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP ' + report_type + '</th> <th> CPP ' + report_type + '</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' ' + report_type + '</th> <th> CPM ' + report_type + '</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Delivered</th><th> CPP Delivered</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Delivered</th> <th> CPM Delivered</th>';

                if (metrics.indexOf('grp') !== -1)
                    html += '<th> GRP Diff.</th><th> GRP Delivered %</th>';
                if (metrics.indexOf('impressions') !== -1)
                    html += '<th> ' + imp_type + ' Diff.</th><th> ' + imp_type + ' Delivered %</th>';
            }
            html +=   '</tr></thead>';

            html += '<tbody>';
            array_dp.sort();
            for(var ind in secondary_demos) {
                sec_array['ord_gri_'+ ind] = 0;
                sec_array['ord_grp_'+ ind] = 0;
            }
            for (var ind in array_dp) {
                var camp = array_dp[ind];
                var cpp = (dayparts_totals[camp].grp > 0) ? dayparts_totals[camp].total / dayparts_totals[camp].grp : 0;
                var cpp_goal = (dayparts_totals[camp].grp_goal > 0) ? dayparts_totals[camp].total / dayparts_totals[camp].grp_goal : 0;
                var perce = 0;
                var grp_dif = 0;

                var perce_imp = 0;
                var div  = (report.type == 'msa') ? 10 : 1;
                var cpm = (dayparts_totals[camp].impressions > 0) ? dayparts_totals[camp].total / (dayparts_totals[camp].impressions /div) : 0;
                var cpm_goal = (dayparts_totals[camp].imp_goal > 0) ? dayparts_totals[camp].total / (dayparts_totals[camp].imp_goal /div): 0;

                for(var ind in secondary_demos){
                    sec_array['ord_gri_'+ ind] += parseFloat(buy_line_values[camp]['total']['sec_demos'][ind]['imp']);
                    sec_array['ord_grp_'+ ind] += parseFloat(buy_line_values[camp]['total']['sec_demos'][ind]['rat']);
                }

                html += '<tr>' +
                    '<td>' + camp + '</td>' ;
                var ord_gross = (typeof buy_line_values[camp] !== 'undefined' && typeof buy_line_values[camp]['total'] !== 'undefined') ? buy_line_values[camp]['total'][1] : 0;
                var ord_ads = (typeof buy_line_values[camp] !== 'undefined' && typeof buy_line_values[camp]['total'] !== 'undefined') ? buy_line_values[camp]['total'][0] : 0;
                var ord_grp =  (typeof buy_line_values[camp] !== 'undefined' && typeof buy_line_values[camp]['total'] !== 'undefined') ? buy_line_values[camp]['total'][2] : 0;
                var ord_gri =  (typeof buy_line_values[camp] !== 'undefined' && typeof buy_line_values[camp]['total'] !== 'undefined') ? buy_line_values[camp]['total'][3] : 0;

                if (parseFloat(ord_gri) > 0)
                    perce_imp = parseFloat((parseFloat(dayparts_totals[camp].impressions) * 100) / parseFloat(ord_gri));
                imp_dif = parseFloat(ord_gri) - parseFloat(dayparts_totals[camp].impressions);

                if (parseFloat(ord_grp) > 0)
                    perce = parseFloat((parseFloat(dayparts_totals[camp].grp) * 100) / parseFloat(ord_grp));
                grp_dif = parseFloat(ord_grp) - parseFloat(dayparts_totals[camp].grp);

                var grp_sym = '';
                var imp_sym = '';
                if(grp_dif !== 0)
                    grp_sym = (grp_dif > 0) ? '-' : '+';
                if(imp_dif !== 0)
                    imp_sym = (imp_dif > 0) ? '-' : '+';

                var ord_cpp = (ord_grp > 0) ? ord_gross / ord_grp : 0;
                var ord_cpm = (ord_gri/ div > 0) ? ord_gross / (ord_gri/div) : 0;
                var del_gross = dayparts_totals[camp].total;
                var cpp = (dayparts_totals[camp].grp > 0) ? del_gross / dayparts_totals[camp].grp : 0;
                var cpm = (dayparts_totals[camp].impressions > 0) ? del_gross / (dayparts_totals[camp].impressions /div) : 0;

                html += '<td>'+ ord_ads+'</td>';
                html += '<td>' + parseFloat(ord_gross).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2
                }), +'</td>';
                html+=    '<td>' + dayparts_totals[camp].ads + '</td>' +
                    '<td>' + parseFloat(dayparts_totals[camp].total).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';

                //main demos part
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(ord_grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(ord_cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(ord_gri).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(ord_cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>' + parseFloat(dayparts_totals[camp].grp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(cpp).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>' + parseFloat(dayparts_totals[camp].impressions).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';

                    html += '<td>' + parseFloat(cpm).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    }), +'</td>';
                }
                if(metrics.indexOf('grp') !== -1) {
                    html += '<td>'+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }
                if(metrics.indexOf('impressions') !== -1) {
                    html += '<td>'+ imp_sym +'' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                    html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                        style: "decimal",
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1,
                    }), +'</td>';
                }

                //secondary demos part
                for(var ind in secondary_demos){
                    //Diff && Percents calculations
                    perce = parseFloat(sec_array['ord_grp_'+ ind]) > 0 ? (parseFloat(dayparts_totals[camp]['grp_' + ind]) * 100) /  parseFloat(sec_array['ord_grp_'+ ind]) : 0;
                    perce_imp = parseFloat(sec_array['ord_gri_'+ ind]) > 0 ? (parseFloat(dayparts_totals[camp]['impressions_' + ind]) * 100) /  parseFloat(sec_array['ord_gri_'+ ind]) : 0;
                    imp_dif = parseFloat(sec_array['ord_gri_'+ ind]) - parseFloat(parseFloat(dayparts_totals[camp]['impressions_'+ ind]));
                    grp_dif = parseFloat(sec_array['ord_grp_'+ ind]) -  parseFloat(dayparts_totals[camp]['grp_'+ ind])
                    grp_sym =  grp_dif > 0 ? '-' : '+';
                    grp_sym =  grp_dif === 0 ? '' : grp_sym;
                    imp_sym = imp_dif > 0 ? '-' : '+';
                    imp_sym = imp_dif === 0 ? '' : imp_sym;

                    //ordered
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_grp_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (sec_array['ord_grp_'+ ind] > 0) ? ord_gross / sec_array['ord_grp_'+ ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(sec_array['ord_gri_'+ ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (sec_array['ord_gri_'+ ind]/ div > 0) ? ord_gross / (sec_array['ord_gri_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //delivered
                    if(metrics.indexOf('grp') !== -1){
                        html += '<td>' + parseFloat(dayparts_totals[camp]['grp_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp =  (dayparts_totals[camp]['grp_' + ind] > 0) ? ord_gross / dayparts_totals[camp]['grp_' + ind] : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td>' + parseFloat(dayparts_totals[camp]['impressions_' + ind]).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        var sec_cpp = (dayparts_totals[camp]['impressions_'+ ind]/ div > 0) ? ord_gross / (dayparts_totals[camp]['impressions_'+ ind]/div) : 0;
                        html += '<td>' + parseFloat(sec_cpp).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2
                        }), +'</td>';
                    }

                    //Diff && Percents HTML
                    if(metrics.indexOf('grp') !== -1) {
                        html += '<td> '+ grp_sym +'' + parseFloat(Math.abs(grp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                    if(metrics.indexOf('impressions') !== -1) {
                        html += '<td> '+ imp_sym+' ' + parseFloat(Math.abs(imp_dif)).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                        html += '<td>' + parseFloat(perce_imp).toLocaleString("en-US", {
                            style: "decimal",
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        }), +'</td>';
                    }
                }
                html += '</tr>';
            }
            html += '</tbody></table></div>';
            $('#totals_summary_tab').html(html);
        };

        //export tab 1 summary
        $('#export_excel_totals').on('click', function () {
            $('#format_x').val('xls');
            $('#grid_tab').val(1);
            var html = '   <input id="overall_op" name="totals_export_options[]" type="checkbox" checked value="overall">' +
                '                                            <label for="overall_op"> Overall Summary</label><br>' +
                '<input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week">' +
                '                                            <label for="week_op">Week Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="daypart">' +
                '                                            <label for="dp_op">Daypart Summary </label><br>' +
                ' <input id="buy_line_op" name="totals_export_options[]" type="checkbox" checked value="buy_line">' +
                '                                            <label for="buy_line_op">Buy Line Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('#export_csv_totals').on('click', function () {
            $('#format_x').val('csv');
            $('#grid_tab').val(1);
            var html = '  <input id="overall_op" name="totals_export_options[]" type="checkbox" checked value="overall">'  +
                '                                                           <label for="overall_op"> Overall Summary</label><br>' +
                '<input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week">' +
                '                                            <label for="week_op">Week Summary</label><br>\n' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="daypart">' +
                '                                            <label for="dp_op">Daypart Summary </label><br>' +
                ' <input id="buy_line_op" name="totals_export_options[]" type="checkbox" checked value="buy_line">' +
                '                                            <label for="buy_line_op">Buy Line Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('#submit_export_totals').on('click', function () {
            show_overlay_loader($("#totalsToExport .modal-content"));
            if($('#grid_tab').val() == 1) {
                type = $('#format_x').val();
                var html_table = '<table class="table table-bordered table-striped table-condensed" >';
                var html_table_end = '</table>';
                var html = '';

                var selectedItems = [];
                $('.all_more_options_totals  input[type=checkbox]').each(function () {
                    if (this.checked)
                        selectedItems.push($(this).val());
                });
                if (selectedItems.indexOf('overall') !== -1) {
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>OVERALL SUMMARY</b></td></tr></table>'
                    html += html_table;
                    html += $('#sta_overall_sum_totals').html();
                    html += html_table_end;
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
                }
                if (selectedItems.indexOf('station') !== -1) {
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>STATION SUMMARY</b></td></tr></table>'
                    html += html_table;
                    html += $('#sta_sum_totals').html();
                    html += html_table_end;
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
                }
                if (selectedItems.indexOf('week') !== -1) {
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>WEEK SUMMARY</b></td></tr></table>'
                    html += html_table;
                    html += $('#week_sum_totals').html();
                    html += html_table_end;
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
                }
                if (selectedItems.indexOf('daypart') !== -1) {
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>DAYPART SUMMARY</b></td></tr></table>'
                    html += html_table;
                    html += $('#dp_code_sum_totals').html();
                    html += html_table_end;
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
                }
                if (selectedItems.indexOf('buy_line') !== -1) {
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td><b>BUY LINE SUMMARY</b></td></tr></table>'
                    html += html_table;
                    html += $('#dp_sum_totals').html();
                    html += html_table_end;
                    html += '<table style="margin-top: 2%; margin-bottom: 2%"><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table>'
                }
                var dt = new Date();
                var day = dt.getDate();
                var month = dt.getMonth() + 1;
                var year = dt.getFullYear();
                var hour = dt.getHours();
                var mins = dt.getMinutes();
                var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
                if (type == 'xls') {
                    var a = document.createElement('a');
                    var data_type = 'data:application/vnd.ms-excel';
                    a.href = data_type + ', ' + encodeURIComponent(html);
                    a.download = 'exported_' + postfix + '.xls';
                    //triggering the function
                    a.click();
                } else {
                    // var url = 'data:application/csv,charset=utf-8,' + encodeURIComponent(html);
                    // location.href = url;
                    // return false;
                    var a = document.createElement('a');
                    var data_type = 'data:application/vnd.ms-csv';
                    a.href = data_type + ', ' + encodeURIComponent(html);
                    a.download = 'exported_' + postfix + '.csv';
                    a.click();
                }
            }
            else if($('#grid_tab').val() == 2){
                var selectedItems = [];
                $('.all_more_options_totals input[type=checkbox]').each(function () {
                    if (this.checked)
                        selectedItems.push($(this).val());
                });
                onBtExportBreakTo(gridCampBreakoutSta, $('#format_x').val(), selectedItems);
            }
            else if($('#grid_tab').val() == 3){
                var selectedItems = [];
                $('.all_more_options_totals input[type=checkbox]').each(function () {
                    if (this.checked)
                        selectedItems.push($(this).val());
                });
                onBtExportBreakTo(gridCampBreakoutWeek, $('#format_x').val(), selectedItems);
            }
            else if($('#grid_tab').val() == 4){
                var selectedItems = [];
                $('.all_more_options_totals input[type=checkbox]').each(function () {
                    if (this.checked)
                        selectedItems.push($(this).val());
                });
                onBtExportBreakTo(gridCampBreakoutDP, $('#format_x').val(), selectedItems);
            }
            else if($('#grid_tab').val() == 5){
                var selectedItems = [];
                $('.all_more_options_totals input[type=checkbox]').each(function () {
                    if (this.checked)
                        selectedItems.push($(this).val());
                });
                onBtExportBreakTo(gridCampBreakoutDPCode, $('#format_x').val(), selectedItems);
            }
            hide_overlay_loader($("#totalsToExport .modal-content"));

            $('#totalsToExport').modal('hide');
        });

        //export station tab#2
        $('.export_station_ex').on('click', function () {
            $('#format_x').val('xls');
            $('#grid_tab').val(2);
            var html = '  <input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week">' +
                '                                            <label for="week_op">Week Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_station_csv').on('click', function () {
            $('#format_x').val('csv');
            $('#grid_tab').val(2);
            var html = '  <input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week">' +
                '                                            <label for="week_op">Week Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_sta_detail_ex').on('click', function (){
            onBtExportBreak(gridCampBreakoutSta,'xls');
        });
        $('.export_sta_detail_csv').on('click', function (){
            onBtExportBreak( gridCampBreakoutSta, 'csv');
        });

        //export weeks tab#3
        $('.export_week_ex').on('click', function () {
            $('#format_x').val('xls');
            $('#grid_tab').val(3);
            var html = '                                               <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week"> ' +
                '                                                       <label for="week_op">Week Summary</label><br>' +
                ' <input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_week_csv').on('click', function () {
            $('#format_x').val('csv');
            $('#grid_tab').val(3);
            var html = '                                               <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="week"> ' +
                '                                                       <label for="week_op">Week Summary</label><br>' +
                ' <input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_week_detail_ex').on('click', function (){
            onBtExportBreak(gridCampBreakoutWeek,'xls');
        });
        $('.export_week_detail_csv').on('click', function (){
            onBtExportBreak( gridCampBreakoutWeek, 'csv');
        });

        //export dp tab#4
        $('.export_dp_ex').on('click', function () {
            $('#format_x').val('xls');
            $('#grid_tab').val(4);
            var html = '  <input id="station_op" name="totals_export_options[]" type="checkbox" checked value="daypart">' +
                '                                            <label for="station_op"> Buy Line Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="week_op">Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_dp_csv').on('click', function () {
            $('#format_x').val('csv');
            $('#grid_tab').val(4);
            var html = '                                               <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="daypart"> +' +
                '                                                       <label for="week_op">Buy Line Summary</label><br>' +
                ' +<input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_dp_detail_ex').on('click', function (){
            onBtExportBreak(gridCampBreakoutDP,'xls');
        });
        $('.export_dp_detail_csv').on('click', function (){
            onBtExportBreak( gridCampBreakoutDP, 'csv');
        });

        //Export Dp CODE last tab added
        $('.export_dp_code_ex').on('click', function () {
            $('#format_x').val('xls');
            $('#grid_tab').val(5);
            var html = '  <input id="daypart_code" name="totals_export_options[]" type="checkbox" checked value="daypart_code">' +
                '                                            <label for="daypart_code"> Daypart Summary</label><br>' +
                '                                            <input id="week_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="week_op">Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_dp_code_csv').on('click', function () {
            $('#format_x').val('csv');
            $('#grid_tab').val(5);
            var html = '                                               <input id="daypart_code" name="totals_export_options[]" type="checkbox" checked value="daypart_code"> +' +
                '                                                       <label for="daypart_code">Daypart Summary</label><br>' +
                ' +<input id="station_op" name="totals_export_options[]" type="checkbox" checked value="station">' +
                '                                            <label for="station_op"> Station Summary</label><br>' +
                '                                            <input id="dp_op" name="totals_export_options[]" type="checkbox" checked value="day">' +
                '                                            <label for="dp_op">Day Summary </label><br>';
            $('.options_page_export').html(html);
            $('#totalsToExport').modal('show');
        });
        $('.export_dp_code_detail_ex').on('click', function (){
            onBtExportBreak(gridCampBreakoutDPCode,'xls');
        });
        $('.export_dp_code_detail_csv').on('click', function (){
            onBtExportBreak( gridCampBreakoutDPCode, 'csv');
        });


        function onBtExportBreakTo(gridOptions, format, selectedItems) {
            var params = {
                skipHeader: false,
                columnGroups: (format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "post-buy-report." + format,

            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Post Buy Analysis"}}
                    ],
                ];
                params.customFooter = [
                    [],
                    []
                ];
            }
            params.shouldRowBeSkipped = function(row){
                if(typeof row.node.key === 'undefined' )
                    return true
                if(selectedItems.indexOf('station') === -1 && row.node.field === 'station')
                    return true;
                if(selectedItems.indexOf('week') === -1 && row.node.field === 'week')
                    return true;
                if(selectedItems.indexOf('day') === -1 && row.node.field === 'day')
                    return true;
                if(selectedItems.indexOf('daypart') === -1 && row.node.field === 'daypart')
                    return true;
                if(selectedItems.indexOf('daypart_code') === -1 && row.node.field === 'daypart_code')
                    return true;
            };
            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridOptions.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                var content = gridOptions.api.getDataAsExcel(params);
                var workbook = XLSX.read(content, {type: 'binary'});
                var xlsxContent = XLSX.writeFile(workbook, 'post-buy-report.xlsx', {bookType: 'xlsx', type: 'base64'});
            }
        }

        function onBtExportBreak(gridOptions, format) {
            var params = {
                skipHeader: false,
                columnGroups: (format == "csv") ? false : true,
                skipFooters: false,
                skipGroups: false,
                skipPinnedTop: false,
                skipPinnedBottom: false,
                allColumns: false,
                onlySelected: false,
                suppressQuotes: false,
                fileName: "post-buy-report." + format,
                skipColumnGroupHeaders: false,
            };
            params.processHeaderCallback = function(header){
                var header_text = header.column.getColDef().headerName.replace('<br>', '');
                return header_text;
            };
            if (format === 'csv') {
                params.customHeader = [];
                params.customFooter = [];
            }else {
                params.customHeader = [
                    [],
                    [
                        {data: {type: 'String', value: 'Report'}},
                        {data: {type: 'String', value: "Post Buy Analysis"}}
                    ],

                ];

                params.customFooter = [
                    [],
                    []
                ];
            }

            if (format === 'csv') {
                console.log("-------------csv-----------------");
                gridOptions.api.exportDataAsCsv(params);
            } else {
                console.log("-------------excel-----------------");
                // gridOptions.api.exportDataAsExcel({
                //     processRowGroupCallback: rowGroupCallback,
                // });
                gridOptions.api.exportDataAsExcel(params);
            }
        }
        function rowGroupCallback(params) {
            return params.node.key;
        }
    }
});
